export const TRANSLATIONS_ES = {
  Wineries: 'Bodegas',
  accept: 'Aceptar',
  accepted: 'Aceptado',
  acceptedBy: 'Aceptado por:',
  acceptedDateOverview: 'Fecha de aceptación: ',
  acceptedService: 'Aceptó {{dictionary.commonTerms.service}}',
  account: 'Cuenta',
  accountAddress: 'Dirección de la cuenta',
  accountHasNotSendTestSetDian: 'Tu cuenta aún no ha enviado el set de pruebas para habilitación por parte de la DIAN',
  accountLogo: 'Logo de la cuenta',
  accountName: 'Nombre de la cuenta',
  accountSetting: 'Configuración de cuenta',
  accountType: 'Tipo de cuenta',
  accounts: 'Cuentas',
  action: 'Accion',
  actionMobilePhone: 'La acción se realizó desde este número de teléfono',
  actions: 'Acciones',
  activateExtendForm: 'Habilitar Formulario Extendido',
  activateExtendFormText:
    'Con este formulario web puedes agregar campos que se deben diligenciar al momento de crear {{dictionary.commonTerms.finalCustomerPlural}}',
  activated: 'Activado',
  activeChats: 'Activos',
  activeGatewayTitle: 'Pasarela activa',
  add: 'Agregar',
  addBlockedDays: 'Agregar días para bloqueo',
  addItem: 'Agregar ítem',
  addListItem: 'Agregar ítem',
  addNote: 'Agregar nota',
  addNotesDescription: 'Permite agregar {{dictionary.commonTerms.notePlural}}',
  addPatientList: 'Agregar {{dictionary.commonTerms.finalCustomer}} a la lista de espera',
  addService: 'Agregar',
  addVariable: '+Agregar',
  additionalFields: 'Campos adicionales',
  additionalForm: 'Formulario adicional',
  additionalInformation: 'Información adicional',
  additionalPhones: 'Teléfonos adicionales',
  address: 'Dirección',
  addressComplement: 'Complemento de direccion',
  addressIsRequired: 'La dirección es obligatoria',
  addressPlaceholder: 'Ingrese una dirección',
  addressRequired: 'La dirección es obligatoria',
  adjustment: 'Ajuste',
  adjustmentNotes: 'Notas de ajuste',
  admin: '{{dictionary.profileNames.admin}}',
  administrateAdvancedAvailability:
    'Puede ver y modificar la disponibilidad avanzada de {{dictionary.profileNames.technicianPlural}}',
  administrateAvailability: 'Puede configurar su disponibilidad',
  administrateQuickAnswers: 'Puede ver y modificar las respuestas frecuentes',
  administrateServices: 'Permite asignar {{dictionary.commonTerms.servicePlural}}',
  administration: 'Administración',
  advancedAvailability: 'Disponibilidad avanzada',
  age: 'Edad',
  alarm: 'Alarma',
  alert: 'Alerta',
  alertResolved: 'Respondió alerta de {{dictionary.commonTerms.service}}',
  alertResolvedBy: 'Alerta resuelta por: ',
  alertResolvedDate: 'Fecha de resolución de alerta: ',
  allPatients: 'Todos los {{dictionary.commonTerms.finalCustomerPlural}}',
  allowAssignServicesTo: 'Permitir asignar Servicios a',
  allowCreation:
    'Crearás esta {{dictionary.commonTerms.service}} sin haber asignado ningún {{dictionary.profileNames.technician}}',
  allowFinalCustomerAssets:
    'Permitir la asociación de {{dictionary.commonTerms.assetPlural}} del {{dictionary.commonTerms.finalCustomer}}',
  allowFinalCustormerService:
    'Permitir que este tipo de {{dictionary.commonTerms.service}} tenga un {{dictionary.commonTerms.finalCustomer}} asociado',
  allowToSubmitServiceTags: 'Permiitir diligenciar tags de {{dictionary.commonTerms.service}}',
  allowToViewAllUsersHistory: 'Permitir visualizar histórico de todos los usuarios',
  allowToViewHistory: 'Permitir ver el historial',
  allowedIncidetnTypes: 'Tipos de {{dictionary.commonTerms.servicePlural}} permitidos',
  alternativeEmail: 'Correo Electrónico alternativo (opcional)',
  amount: 'Monto',
  amountPaid: 'Monto pagado',
  amountRequired: 'Monto requerido',
  amountsConfiguration: 'Configuración de Montos',
  annulled: 'Anulada',
  answerCreate: 'Crear Respuesta',
  answerDate: 'Fecha De Respuesta',
  answerEdit: 'Editar Respuesta',
  answers: 'Respuestas',
  answersFrequent: 'Respuestas Frecuentes',
  api: 'API',
  apiAdminOptions: 'Habilitar API (opciones de administración)',
  apiCreate: '+ Crear nuevo Api key',
  apiMessage: 'Este es tu Api key',
  apiMessageWhatsapp: 'Este es tu código o key. Usa este para colocarlo en la configuración de Meta',
  appColorMobile: 'Colores app móvil',
  appColorText:
    'Selecciona un esquema de colores, éstos serán usados en algunas secciones o botones de la aplicación móvil.',
  appMobileOptions: 'Opciones de configuración App móvil',
  appPlaceholder: 'Seleccione un formulario de {{dictionary.commonTerms.service}}',
  apply: 'Aplicar',
  applyExpirationRules: 'Aplicar semáforo a fechas de vencimiento',
  appoinmentNoAvailable:
    'No hay {{dictionary.commonTerms.servicePlural}} disponibles bajo estos criterios de búsqueda, seleccione otras opciones y busque nuevamente.',
  appointment: '{{dictionary.commonTerms.servicePlural}}',
  appointmentAssignation: 'Asignación de {{dictionary.commonTerms.service}}',
  appointmentAssignmentMessage:
    'Está intentando asignar las siguientes {{dictionary.commonTerms.servicePlural}} al {{dictionary.commonTerms.finalCustomer}}',
  appointmentAvailable: 'Citas Disponibles',
  appointmentCancelation: 'Cancelación de {{dictionary.commonTerms.service}}',
  appointmentConfirm: '{{dictionary.commonTerms.service}} confirmada',
  appointmentModified: 'Modificación de {{dictionary.commonTerms.service}}',
  appointmentNotification:
    'Me gustaria recibir notificaciones en caso de que se pueda adelantar mi cita y autorizo a que me contacten a mi numero de celular',
  appointmentOpportunitiesReport: 'Reporte de oportunidades de {{dictionary.commonTerms.servicePlural}}',
  appointmentRepeat: 'Repetir {{dictionary.commonTerms.service}}',
  appointmentScheduledSuccessfully: 'Tu cita se ha agendado exitosamente',
  appointmentScheduledToDate: 'para el {{date}} a las {{time}}',
  appointmentsOf: ' Citas de ',
  areYouSure: '¿Está seguro?',
  asset: '{{dictionary.commonTerms.asset}}',
  assetActive: 'Activo',
  assetHasOverlaps:
    '{{dictionary.commonTerms.asset}} tiene {{dictionary.commonTerms.servicePlural}} que se cruzan en el mismo horario',
  assetInactive: 'Inactivo',
  assetInformation: 'Información de {{dictionary.commonTerms.asset}}',
  assetNotAvailable: '{{dictionary.commonTerms.asset}} no disponible en este horario',
  assetPlaceholder: 'Seleccione {{dictionary.commonTerms.asset}}',
  assetReference: 'Id o Ref',
  assetReferenceAlreadyExists: 'El Id o Referencia ya se encuentra registrado',
  assetRequired: 'Se requiere seleccionar un Activo al asignar este tipo de {{dictionary.commonTerms.servicePlural}}',
  assetRequiredField: 'Es necesario seleccionar {{dictionary.commonTerms.asset}}',
  assetTypes: 'Tipos de {{dictionary.commonTerms.assetPlural}}',
  assets: '{{dictionary.commonTerms.assetPlural}}',
  assetsDescription:
    'Crea listados de Activos que funcionan como bases de datos que pueden ser usados en los formularios, creación de {{dictionary.commonTerms.service}}, entre otros.',
  assetsGeolocalization: 'Geolocalización de {{dictionary.commonTerms.assetPlural}}',
  assetsGeolocalizationDescription:
    'Visualiza la ubicación de grupos de {{dictionary.commonTerms.assetPlural}} y su cercanía a algún punto clave',
  assetsGroup: 'Selecciona el grupo de {{dictionary.commonTerms.assetPlural}} que corresponde a este tipo de Cita',
  assetsList: 'Listado de {{dictionary.commonTerms.assetPlural}}',
  assigmentAppoinment: 'Agendamiento de',
  assign: 'Asignar',
  assignFinalCustomer: 'Asignar {{dictionary.commonTerms.finalCustomer}}',
  assignIncidentOffSchedule: 'Asignar {{dictionary.commonTerms.service}} fuera de horario',
  assignNameToIdentifySurvey: 'Asigna un nombre para identificar este(a) {{dictionary.commonTerms.survey}}',
  assignToFinalCustomer: 'Asignar a {{dictionary.commonTerms.finalCustomer}}',
  assignationFinalCustomer: 'Asignación de {{dictionary.commonTerms.finalCustomerPlural}}',
  assignedCompany: 'Compañia',
  assignedCompanyText: 'Asignar a un {{dictionary.commonTerms.customer}}',
  assignedDate: 'Fecha asignada',
  assignedDateOverview: 'Fecha de asignación',
  assignedFinalCustomer: 'Asignar {{dictionary.commonTerms.finalCustomer}}',
  assignedFinalCustomerText: 'Asignar a un {{dictionary.commonTerms.finalCustomer}}',
  assignedService: 'Asignó {{dictionary.commonTerms.service}}',
  assignedTo: 'Asignado a',
  assignedUser: '{{dictionary.profileNames.technicianPlural}}',
  assignments: 'asignaciones',
  associatedForm: 'Formulario asociado',
  atLeastOneDateRangeMustBeSelected: 'Debe seleccionar al menos un rango de fechas',
  attachFiles: 'Adjuntar archivos',
  attachPDF: 'Adjuntar PDF:',
  attachmentWillBeRemoved: 'El adjunto: "{{filename}}" será eliminado',
  attachments: 'Adjuntos',
  attendChat: 'Atender chat',
  audio: 'Audio',
  author: 'Operador',
  autoCalculateStockValues: 'Calcular automáticamente valores máximos y mínimos',
  automaticInvoiceSend: 'Envío automático de factura',
  automaticNotification: 'Notificación automática',
  automaticSend: 'Envío automático',
  availability: 'Configurar Disponibilidad',
  availabilityDesccription:
    'Configura la disponibilidad de tus {{dictionary.profileNames.technicianPlural}} bajo múltiples parámetros, como {{dictionary.commonTerms.headquarter}} o tipo de {{dictionary.commonTerms.service}}.',
  availabilityTitle: 'Disponibilidad',
  available: 'Disponible',
  awaitingList: 'Lista de espera',
  awaitingListDescription:
    'Crea un listado con  {{dictionary.commonTerms.finalCustomerPlural}} que están en espera para la asignación de {{dictionary.commonTerms.servicePlural}} o adelantar asignaciones actuales.',
  backToHome: 'Volver al inicio',
  bannerSizeXY: 'Banner (tamaño {{x}} por {{y}})',
  barcode: 'Código de barras',
  basePrice: 'Precio base',
  basename: 'Nombre base',
  basenamePlaceholder: 'ingrese nombre base',
  billableServices: '{{dictionary.commonTerms.servicePlural}} facturables',
  billed: 'Facturado',
  billing: 'Facturación',
  billingCompanyDuplicated: 'La compañía ya se encuentra registrada',
  billingConfiguration: 'Configuración de facturación',
  billingCreditNoteRejectedByDian: 'La nota crédito ha sido rechazada por la DIAN',
  billingCustomers: 'Clientes para facturación',
  billingDescription:
    'Realiza la facturación electrónica de tus {{dictionary.commonTerms.servicePlural}} y genera los documentos asociados',
  billingInvoiceCommunicationError: 'Ha ocurrido un error en la comunicación con la DIAN',
  billingInvoiceRejectedByDian: 'La factura ha sido rechazada por la DIAN',
  billingServices: 'Facturación de {{dictionary.commonTerms.servicePlural}}',
  biologicalSex: 'Sexo biológico',
  biologicalSexPlaceholder: 'Seleccione un sexo biológico',
  biologicalSexRequired: 'El sexo biológico es obligatorio',
  birthDate: 'Fecha de nacimiento',
  birthdatePlaceholder: 'Ingrese una fecha de nacimiento',
  birthdateRequired: 'La fecha y hora de nacimiento es obligatoria',
  blackTheme: 'Negro',
  blockDays: 'Bloquear días específicos',
  blockDaysdescription: 'Puedes agregar bloqueos en el agendamiento para días y horas espcecíficas',
  blockSchedule: 'Bloquear agenda',
  blockedDays: 'Días bloqueados',
  bloodType: 'Grupo sanguíneo',
  bloodTypePlaceholder: 'Seleccione un grupo sanguíneo',
  bloodTypeRequired: 'El grupo sanguíneo es obligatorio',
  blueTheme: 'Azúl',
  boardFields: 'Campos del Tablero',
  calendar: 'Calendario',
  calendarFilters: 'Filtrar calendario',
  canCreateAllServices:
    'Permitir crear todos los tipos de {{dictionary.commonTerms.service}} relacionados con su {{dictionary.commonTerms.skills}}',
  canCreateIncidentNotes: 'Puede agregar {{dictionary.commonTerms.notePlural}}',
  canCreateServices: 'Puede crear {{dictionary.commonTerms.servicePlural}}',
  canDeleteIncidentNotes: 'Puede borrar {{dictionary.commonTerms.notePlural}}',
  canEditAssets: 'Puede editar {{dictionary.commonTerms.assetPlural}}',
  canEditCustomers: 'Puede editar {{dictionary.commonTerms.customerPlural}}',
  canEditFinalCustomers: 'Puede Editar {{dictionary.commonTerms.finalCustomerPlural}}',
  canEditReviewForm: 'Puede editar formulario de {{dictionary.commonTerms.review}}',
  canEditServicesSummary:
    'Puede ver íconos de edición del {{dictionary.commonTerms.summary}} de {{dictionary.commonTerms.service}}',
  canSeeSurveyMenu: 'Puede ver {{dictionary.commonTerms.surveyPlural}}',
  canViewAndCreateAdjustmentNotes: 'Puede ver y crear Notas de ajuste',
  canViewAndCreateBilling: 'Puede ver y crear facturas',
  canViewAndCreateCreditNotes: 'Puede ver y crear Notas crédito',
  canViewAssets: 'Puede ver {{dictionary.commonTerms.assetPlural}}',
  canViewBilling: 'Puede ver configuración de Facturación',
  canViewCustomers: 'Puede ver {{dictionary.commonTerms.customerPlural}}',
  canViewFinalCustomers: 'Puede ver {{dictionary.commonTerms.finalCustomerPlural}}',
  canViewIncidentNotes: 'Puede ver {{dictionary.commonTerms.notePlural}}',
  canViewInventory: 'Puede ver inventario',
  canViewResourceTracking: 'Puede ver vista de seguimiento de {{dictionary.profileNames.technicianPlural}}',
  canViewReviewForm: 'Puede ver formulario de {{dictionary.commonTerms.review}}',
  canViewServicesHistory: 'Puede ver historial de {{dictionary.commonTerms.servicePlural}}',
  canViewServicesSummary: 'Puede ver {{dictionary.commonTerms.summary}} de {{dictionary.commonTerms.service}}',
  cancel: 'Cancelar',
  cancelAvailability: 'Está intentando cancelar la disponibilidad de',
  cancelSequenceStep: 'Cancelar paso',
  cancelationDate: 'Fecha de cancelación: ',
  canceled: 'Cancelado',
  canceledByFinalCustomer: 'Canceló {{dictionary.commonTerms.service}}',
  canceledService: 'Canceló {{dictionary.commonTerms.service}}',
  canceledStep: 'finalizó el paso',
  cancelingAvailabilityOf: 'Está intentando cancelar la disponibilidad de',
  cancelingAvailabilityOfCalendar: 'Está intentando cancelar {{dictionary.commonTerms.servicePlural}} de',
  cancellationDate: 'Fecha',
  cancellationReasson: 'Motivo de cancelación',
  cancellationReassons: 'Motivos de cancelación',
  cancelled: 'Canceló {{dictionary.commonTerms.service}}',
  cancelledBy: 'Cancelado por: ',
  cancelledByFinalCustomer: 'Canceló {{dictionary.commonTerms.service}}',
  cancelledService: 'Permitir ofertar {{dictionary.commonTerms.servicePlural}} después de su cancelación',
  cantBeEmpty: 'No puede estar vacío',
  cantHaveSpaces: 'No puede tener espacios',
  cantSaveRecord: 'No se puede guardar el registro',
  categories: 'Categorías',
  category: 'Categoría',
  categoryTab: 'Category',
  changeField: 'Cambió el campo :',
  changeStatus: 'Cambiar estado',
  changesWillNotBeSaved: 'Los cambios no serán guardados',
  characterText: 'de {{n}} caracteres',
  chat: 'Chat',
  chatActive: 'Chat activo',
  chatCancelled: 'Chat cancelado',
  chatCancelledTag: 'Cancelado',
  chatClosed: 'Chat cerrado',
  chatClosedTag: 'Cerrado',
  chatConfiguration: 'Configuración de chat',
  chatFinishConfirmMessage: 'El chat será finalizado y no se podrán enviar nuevos mensajes',
  chatFinished: 'Chat finalizado',
  chatOpen: 'Chat activo',
  chatOpenTag: 'Activo',
  chatRejectedTag: 'Rechazado',
  chatUnassigned: 'Chat sin asignar',
  chatUnassignedTag: 'Sin asignar',
  chatWaitForFinalCustomerResponseTag: 'Esperando respuesta',
  chatWillBeAssignedToYou: 'El chat será asignado a ti',
  chatWillBeFinished: 'El chat será finalizado',
  checkStatusPayment: 'Comprobar estado',
  cityPlaceholder: 'Seleccione una ciudad de residencia',
  clear: 'Limpiar',
  clickOrDragToUpload: 'De click o arrastre hacia esta área para subir un archivo',
  clientType: 'Tipo de cliente',
  close: 'Cerrar',
  closed: 'Cerrado',
  closedChats: 'Cerrados',
  code: 'Código',
  codeReference: 'Código o referencia',
  collaborators: 'Colaboradores',
  collaboratorsPlaceholder: 'Seleccione colaboradores',
  color: 'Color',
  colorApplication: 'Color de aplicación',
  colorMark: 'Marcación de color',
  colorPlaceholder: 'Ingrese color',
  colorRequired: 'Es necesario seleccionar un color',
  comment: 'Comentario',
  commentInvoiceItem: 'Comentario a ítem de factura',
  compactView: 'Vista compacta',
  companion: 'Acudiente/Acompañante/Responsable',
  company: '{{dictionary.commonTerms.customer}}',
  companyAddress: 'Dirección {{dictionary.commonTerms.customer}}',
  companyName: 'Nombre o Razón social',
  completeName: 'Nombre completo',
  completedFormMobileBy: 'Formulario de {{dictionary.commonTerms.service}} completado por: ',
  completedFormMobileDate: 'Fecha completado: ',
  completedFormReviewBy: 'Formulario completado por: ',
  completedFormReviewDate: 'Fecha completado formulario: ',
  completedMobileForm: 'Completó formulario de {{dictionary.commonTerms.service}}',
  completedReviewForm: 'Modificó Formulario de {{dictionary.commonTerms.review}}',
  concept: 'Concepto',
  conceptPlaceholder: 'Seleccione un concepto',
  conditionalValueRequired: 'Faltan valores condicionales obligatorios',
  config: 'Configuración',
  configAppMobileOptions: 'Opciones de configuración de App Móvil',
  configTemplates: 'Configurar plantillas',
  configUserMessage: 'Selecciona el tipo de usuario, ingresa la información básica y asigna una contraseña',
  configuration: 'Configuración',
  configured: 'Configurado',
  confirm: 'Confirmar',
  confirmPassword: 'Confirmar contraseña',
  confirmSuspendSurvey:
    'El {{dictionary.commonTerms.finalCustomer}} no recibirá más {{dictionary.commonTerms.surveyPlural}}. Esta acción no se puede deshacer',
  confirmation: 'Confirmación',
  confirmedByFinalCustomer: 'Confirmado por {{dictionary.commonTerms.finalCustomer}}',
  confirmedByFinalCustomerDate: 'Fecha de confirmación {{dictionary.commonTerms.finalCustomer}}: ',
  confirmedByUser: 'Confirmado por {{dictionary.profileNames.operator}}',
  confirmedService: 'Confirmó {{dictionary.commonTerms.service}}',
  confirmedServiceDescription: 'Se marcará como confirmado',
  consecutive: 'Consecutivo',
  contact: '{{dictionary.commonTerms.contact}}',
  contactAddress: 'Dirección de {{dictionary.commonTerms.contact}}',
  contactName: 'Nombre de {{dictionary.commonTerms.contact}}',
  contactNumber: 'Número de {{dictionary.commonTerms.contact}}',
  contactPhone: 'Telefono de {{dictionary.commonTerms.contact}}',
  contactPlaceholder: 'Seleccione {{dictionary.commonTerms.contact}}',
  contactReference: 'Referencia de {{dictionary.commonTerms.contact}}',
  contactRequired: '{{dictionary.commonTerms.contact}} es obligatorio',
  contacts: '{{dictionary.commonTerms.contactPlural}}',
  container: 'Contenedor',
  continue: 'Continuar',
  contractNumber: 'Número de contrato',
  contractPaymentMethod: 'Modalidad de pago de contrato',
  conversationHistory: 'Historial de conversaciones',
  couldNotUploadFile: 'No se pudo subir el archivo: {{filename}}',
  country: 'País',
  countryPlaceholder: 'Seleccione un país',
  countryRequired: 'Debe seleccionar un país',
  create: 'Crear',
  createAccount: 'Crear Cuenta',
  createAppointment: 'Crear {{dictionary.commonTerms.servicePlural}}',
  createAsset: 'Crear {{dictionary.commonTerms.asset}}',
  createAssetType: 'Crear tipo de {{dictionary.commonTerms.asset}}',
  createAvailability: 'Nueva Disponibilidad',
  createCancellationReasson: 'Crear motivo de cancelación',
  createContact: 'Crear {{dictionary.commonTerms.contact}}',
  createCustomer: 'Crear {{dictionary.commonTerms.customer}}',
  createCustomerTextOptions: 'Permitir crear y modificar {{dictionary.commonTerms.customerPlural}} desde la app móvil',
  createDiary: 'Creación de agenda',
  createDictionary: ' Crear Diccionario',
  createFinalCustomer: 'Crear {{dictionary.commonTerms.finalCustomer}}',
  createFinalCustomerTag: 'Crear Tag para {{dictionary.commonTerms.finalCustomer}}',
  createFinalCustomerTextOptions:
    'Permitir crear y modificar {{dictionary.commonTerms.finalCustomerPlural  }} desde la app móvil',
  createHeadquarter: 'Crear {{dictionary.commonTerms.headquarter}}',
  createHere: 'Puedes crearlos desde acá.',
  createItem: 'Crear Item',
  createKey: '+ Crear nuevo key',
  createLink: 'Crear link',
  createLinkPayment: 'Crear link de pago',
  createList: 'Crear lista',
  createListNode: 'Agregar nodo',
  createMenu: 'Crear Menú',
  createNode: 'Crear Nodo',
  createNote: 'Crear {{dictionary.commonTerms.note}}',
  createNotes: 'Crear {{dictionary.commonTerms.note}}',
  createNotesType: 'Crear tipo de {{dictionary.commonTerms.notePlural}}',
  createNotification: 'Crear notificación',
  createSequence: 'Crear Secuencia',
  createService: 'Crear {{dictionary.commonTerms.service}}',
  createServicesFromMobile: 'Crear {{dictionary.commonTerms.servicePlural}} para movil',
  createServicesTextOptions: 'Permitir crear {{dictionary.commonTerms.servicePlural}} desde la app móvil',
  createSkill: 'Crear {{dictionary.commonTerms.skillsPlural}}',
  createSurvey: 'Crear {{dictionary.commonTerms.survey}}',
  createSurveyGroup: 'Crear grupo de {{dictionary.commonTerms.surveyPlural}}',
  createUser: 'Crear usuario',
  created: '¡Creado!',
  createdAt: 'Fecha Creación',
  createdBy: 'Creado por: ',
  createdPayment: 'Creado',
  createdRecords: 'Registros creados',
  createdService: 'Creó {{dictionary.commonTerms.service}}',
  creationDate: 'Fecha de creación',
  creationOfRequests: 'Creación de solicitudes',
  creationOfRequestsDescription:
    'Si habilitas esta opción, el usuario interesado podrá crear una solicitud de un {{dictionary.commonTerms.service}} , este quedará con el estado Solicitado y requerirá que un administrador u {{dictionary.profileNames.operator}} asigne un {{dictionary.profileNames.technician}}  y defina el Tipo de {{dictionary.commonTerms.service}} ',
  creationType: 'Tipo de creación',
  creationTypePlaceholder: 'Seleccione Tipo de Agendamiento',
  creator: 'Creador',
  credentialsError: 'Error con las credenciales de acceso',
  creditNote: 'Nota crédito',
  creditNoteTemplate: 'Plantilla nota crédito',
  creditNotes: 'Notas crédito',
  currency: 'Moneda',
  currencyDuplicate: 'No puedes usar de nuevo esta moneda',
  currencyRequired: 'Moneda requerida',
  currentAmount: 'Cantidad actual',
  currentAmountRequire: 'La cantidad es obligatoria',
  currentConsecutive: 'Consecutivo actual',
  currentStock: 'Stock actual',
  currentValue: 'Valor actual',
  custom: 'Personalizado',
  customFieldPlaceholder: 'Ingrese {{label}}',
  customFooterImage:
    'Usa una imagen personalizada para mostrar en el pie de página. El tamaño de la imagen debe ser de 782px x 80px (Ancho - Alto)',
  customHeaderImage:
    'Usa una imagen personalizada para mostrar en el encabezado de página. El tamaño de la imagen debe ser de 782px x 80px (Ancho - Alto)',
  customImageForReports:
    'Usa una imagen personalizada para mostrar en los reportes. El tamaño de la imagen debe ser de 360px x 135px (Ancho - Alto)',
  customList: 'Lista Personalizada',
  customLists: 'Listas Personalizadas',
  customListsPlaceholder: 'Seleccione una lista Personalizada',
  customPDFImagesText: 'PDF estándar con imágenes diferentes',
  customPDFTemplateText: 'PDF completamente personalizado',
  customPdfDescription:
    'Si habilitas esta opción los PDF que se generen a partir de la información de los tipos de Cita se verán acorde a la configuración del PDF personalizado',
  customPdfText: 'Usar un PDF personalizado para este tipo de {{dictionary.commonTerms.service}}',
  customReportSettings: 'Configuración de reportes',
  customTemplate: 'Seleccione una plantilla',
  customer: '{{dictionary.commonTerms.customer}}',
  customerLabel: 'Cliente',
  customerLocation: 'Ubicación de {{dictionary.commonTerms.customer}}',
  customerName: 'Nombre de {{dictionary.commonTerms.customer}}',
  customerPhone: 'Telefono de {{dictionary.commonTerms.customer}}',
  customerPlaceholder: 'Seleccione {{dictionary.commonTerms.customer}}',
  customerPlaceholderLabel: 'Seleccione cliente',
  customerRequired: '{{dictionary.commonTerms.customer}} es obligatorio',
  customers: '{{dictionary.commonTerms.customerPlural}}',
  customersDescription:
    'Si tu entidad maneja listas de {{dictionary.commonTerms.customerPlural}}, podrás seleccionar el {{dictionary.commonTerms.customer}} específico al crear la {{dictionary.commonTerms.service}}',
  customersLabel: 'Clientes',
  customersToView: '{{dictionary.commonTerms.customerPlural}} a visualizar',
  customizationAdminOptions: 'Habilitar personalización (opciones de administración)',
  dashboard: 'Dashboard',
  dataBasic: 'Datos básicos',
  dataPolicyMessage: 'política de datos ',
  dataTreatment: 'Tratamiento de datos',
  date: 'Fecha',
  dateAndHour: 'Fecha de asignación',
  dateOfLastMessage: 'Fecha de último mensaje',
  dateOfRegistration: 'Fecha de registro',
  dateSend: 'Fecha De Envío',
  datesAvailablesNotFound:
    '¿No encontraste fechas disponibles para la {{dictionary.commonTerms.service}} que necesitas?',
  day: 'Día',
  days: 'Días',
  daysToExpire: 'Días para expiración',
  decimalError: 'Solo se aceptan valores enteros',
  defaultPaymentTerm: 'Plazo de pago por defecto (días)',
  delete: 'Eliminar',
  deleteStatus: 'Borrado',
  departamentPlaceholder: 'Seleccione el departamento de residencia',
  departmentPlaceholder: 'Seleccione un departamento de residencia',
  description: 'Descripción',
  descriptionErrorNotification: 'Ya se tiene una notificación con esta misma configuración',
  descriptionOrComment: 'Descripción o comentario',
  descriptionPlaceholder: 'Ingrese una descripción',
  descriptionRequired: 'La descripción es obligatoria',
  descriptionSelectServiceTypeClient:
    'Selecciona los tipos de {{dictionary.commonTerms.service}} para este {{dictionary.commonTerms.customer}}',
  descriptionSelfScheduling:
    'Habilita un enlace para permitir que tus {{dictionary.commonTerms.finalCustomerPlural}} realicen el agendamiento de {{dictionary.commonTerms.servicePlural}} por su cuenta',
  desiredStock: 'Stock deseado',
  desiredstock: 'Stock Deseado',
  destination: 'Destino',
  destinationRequired: 'El campo de destino es requerido',
  devices: 'Dispositivos',
  dianAuthorization: 'Autorización DIAN',
  dianAuthorizationDescription: 'Ingresa la información correspondiente para la DIAN',
  dianRegistrationInformation: 'Información de registro DIAN',
  diary: 'Agenda',
  dictionary: 'Diccionario',
  didUnassignIncident: 'No asignó {{dictionary.commonTerms.service}}',
  didUpdateService: 'Actualizó información de {{dictionary.commonTerms.service}}',
  digitalCertificate: 'Certificado digital',
  digitalSignatureIsUploaded: 'Ya cargaste tu firma digital',
  diligence: 'Diligenciar',
  disableAudio: 'Desactivar audio al entrar',
  disableLeaveButton: 'Desactivar botón de salida',
  disablePeopleList: 'Desactivar lista de personas',
  disableVideo: 'Desactivar video al entrar',
  disabled: 'No Habilitado',
  discount: 'Descuento',
  displayOptions: 'Opciones de visualización',
  displayReviewFormOnlyOnAlert: 'Mostrar formulario de revisión solo en caso de alerta',
  distance: 'Distancia',
  doctor: 'Médico',
  documentNumberNotRegistered:
    'Lo sentimos, su número de documento no registra en el sistema por lo que no es posible realizar el agendamiento de su {{dictionary.commonTerms.service}}. Por favor comuníquese con la entidad para resolver su solicitud',
  documentTooLong: 'La longitud de {{documentType}} debe ser máximo de {{maxLength}} dígitos',
  documentTooShort: 'La longitud de {{documentType}} debe ser mínimo de {{minLength}} dígitos',
  documentType: 'Tipo de documento',
  documentTypePlaceholder: 'Selecione el tipo de documento',
  documentTypeRequired: 'El tipo de documento es obligatorio',
  documents: 'Documentos',
  documentsSetting: 'Configuración de documentos',
  download: 'Descargar',
  downloadBaseTemplate: 'Descargar plantilla base para importar las listas',
  downloadFormat: 'Formato de descarga',
  downloadImportsTemplateFile: 'Descargar plantilla base para importaciones',
  downloadReport: 'Descarga de reporte',
  downloadServiceFiles: 'Descargar archivos de {{dictionary.commonTerms.service}}',
  downloadSingular: 'Descarga',
  downloadTemplate: 'Descargar plantilla',
  doyouAgree: '¿Está de acuerdo?',
  draft: 'Borrador',
  duration: 'Duración',
  durationPlaceholder: 'Selecciona la duracion',
  durationService:
    'La duración de la {{dictionary.commonTerms.service}} es igual para todos los {{dictionary.profileNames.technicianPlural}}',
  edit: 'Editar',
  editAccount: 'Editar cuenta',
  editAvailability: 'Editar Disponibilidad',
  editCancellationReasson: 'Editar motivo de cancelación',
  editContact: 'Editar {{dictionary.commonTerms.contact}}',
  editCustomer: 'Editar {{dictionary.commonTerms.customer}}',
  editDictionary: 'Editar Diccionario',
  editFinalCustomer: 'Editar {{dictionary.commonTerms.finalCustomer}}',
  editFinalCustomerTag: 'Editar Tag para {{dictionary.commonTerms.finalCustomer}}',
  editHeadquarter: 'Editar {{dictionary.commonTerms.headquarter}}',
  editIncidentType: 'Editar tipo de {{dictionary.commonTerms.service}}',
  editInfoCustomers: 'Puede modificar información de {{dictionary.commonTerms.customerPlural}}',
  editInventory: 'Editar inventario',
  editMainPage: 'Editar página principal',
  editMenu: 'Editar Menú',
  editNotesType: 'Editar tipo de nota',
  editNotification: 'Editar notificación',
  editSequence: 'Editar Secuencia',
  editService: 'Editar {{dictionary.commonTerms.service}}',
  editSkill: 'Editar {{dictionary.commonTerms.skillsPlural}}',
  editState: 'Editar Estado',
  editSurvey: 'Editar Encuesta',
  editSurveyGroup: 'Editar grupo de encuesta',
  editUser: 'Editar usuario',
  editVariable: 'Editar Variable',
  email: 'Correo electrónico',
  emailAlreadyExists: 'Correo electrónico ya existe',
  emailExample: 'hola@netuxtecnologia.com',
  emailMenu: 'Email',
  emailPlaceholder: 'Ingrese el correo electrónico',
  emailRecipient: 'Correo electrónico de la persona que recibirá la notificación',
  emailRequired: 'El correo electrónico es obligatorio',
  emailsToSent: 'Correo electrónico de la personas que recibirá la notificación',
  emergency: 'emergencias',
  emergencyContact: 'Contacto de emergencia:',
  emergencyWork: 'Atención en campo o',
  employee: 'Empleado',
  employeePlural: 'Empleados',
  enable: 'Habilitado',
  enableAvailability: 'Habilitar Disponibilidad',
  enableChat: 'Activar chat',
  enableCustomPdf: 'Habilitar PDF personalizado',
  enableExcelExportation: 'Habilitar botón de exportación en excel',
  enableExtendedFields: 'Habilita otros campos',
  enableForReception: 'Bodega de recepción',
  enableForcedAvailabilityLocks: 'Habilitar la creación de bloqueos de disponibilidad de forma forzada',
  enableForm: 'Habilitar Formulario de {{dictionary.commonTerms.review}}',
  enableGeolocalization: 'Activar geolocalización',
  enablePaymentGatewaysTitle: 'Habilitar pasarelas de pago',
  enableRecording: 'Activar grabación',
  enableScreenshare: 'Permitir compartir pantalla',
  enableSelfscheulding: 'Habilitar esta disponibilidad para autoagendamiento web',
  enableSendEmailButton: 'Habilitar botón de envío de correo',
  enableServiceTypeForSelfScheduling: 'Habilitar tipo de {{dictionary.commonTerms.service}} para autoagendamiento',
  enableServiceTypesClient:
    '¿Quieres habilitar todos los tipos de {{dictionary.commonTerms.service}} para este {{dictionary.commonTerms.customer}}?',
  enableSupportChat: 'Habilitar chat de soporte',
  enableToAssignIncidentsOutOfSchedule:
    'Habilitar asignación de {{dictionary.commonTerms.servicePlural}} fuera del horario asignado',
  enabledProductionEnviroment: 'Activar ambiente de producción',
  enabledUsers: 'Usuarios habilitados',
  enabling: 'Habilitación',
  enablingCode: 'Código de habilitación',
  enablingCodeValidationPattern: 'Debe ser un número entre 1 y 12 dígitos',
  end: 'Fin',
  endDate: 'Fecha de fin',
  endHour: 'Hora de fin',
  endUseWarehouse: 'Bodega de consumo final',
  endpoint: 'Endpoint',
  endpointRequired: 'Endpoint obligatorio',
  english: 'Inglés',
  enterDateList: 'Fecha de ingreso a lista',
  enterDatePlaceholder: 'Ingrese una fecha',
  enterNote: 'Ingresar {{dictionary.commonTerms.note}}',
  enterSession: 'Ingresar',
  enterSubject: 'Ingrese el asunto del correo electronico',
  enterYourData: 'Registra tus datos',
  enterprise: 'Empresa',
  enterpriseName: 'Nombre de la empresa',
  enterprisePlaceholder: 'Netux S.A.S',
  entityName: 'Nombre de entidad',
  eps: 'Eps',
  error: 'Error',
  errorAddingInAwaitingList: 'Ocurrió un error al intentar ser añadido a la lista de espera',
  errorCancelingService: 'Ocurrió un error durante la cancelación de {{dictionary.commonTerms.service}}',
  errorCantSendMessageToClosedChat: 'No se puede enviar mensajes a un chat cerrado',
  errorChatAlreadyAssignedToCurrentUser: 'El chat ya se encuentra asignado a otro usuario',
  errorChatAssignedToAnotherUser: 'El chat se encuentra asignado a otro usuario',
  errorChatNotActive: 'El chat no se encuentra activo',
  errorChatNotFound: 'Chat no encontrado',
  errorCreateMessage: 'Ocurrió un error al crear mensaje',
  errorCreatingPaymentLink: 'No se pudo generar el link de pago',
  errorCreatingRecord: 'Ocurrió un error creando el registro',
  errorDeleteSkill: 'Se ha producido un error al intentar eliminar el registro',
  errorFinishingService: 'Ocurrió durante la finalización de {{dictionary.commonTerms.service}}',
  errorGeneratingReport: 'Error generando reporte',
  errorRecordAlreadyExists: 'El registro ya existe',
  errorRecordNotFound: 'No se encontró el registro',
  errorRemovingRecord: 'Ocurrió un error eliminando el registro',
  errorRetrievingColors: 'Ocurrió un error cargando los colores',
  errorRetrievingGeolocation: 'Error obteniendo ubicación geografica',
  errorRetrievingRecord: 'Ocurrió un error obteniendo el registro',
  errorRetrievingRecords: 'Ocurrió un error obteniendo los registros',
  errorSendingEmail: 'Ocurrió un error enviado el correo',
  errorSendingNotification: 'Ocurrió un error al enviar notificación',
  errorSignDocument: 'Ocurrió un al guardar la firma, por favor intentelo de nuevo',
  errorSuspendingSurvey: 'Ocurrió un error al suspender las {{dictionary.commonTerms.surveyPlural}}',
  errorUpdatingRecord: 'Ocurrió un error actualizando el registro',
  errorUploadingFile: 'Ocurrió un error subiendo el archivo',
  errorValidateFile: 'Ocurrió un error al subir el archivo para su validación',
  executionDate: 'Fecha de ejecución',
  executionTime: 'Hora de ejecución',
  expirationDate: 'Fecha de vencimiento',
  export: 'Exportar',
  exportPdf: 'Exportable PDF',
  exportToPdf: 'Exportables en PDF',
  extendForm:
    'Con este formulario web puedes agregar campos que se deben diligenciar al momento de crear {{dictionary.commonTerms.servicePlural}}.',
  extendedExternalForm: 'Formulario Externo Extendido',
  extendedExternalFormParagraph: 'Con este formulario puede extender la información requerida para el autogendamiento',
  extension: '{{dictionary.commonTerms.extension}}',
  extensionLabel: 'Extensión',
  extensionPlural: '{{dictionary.commonTerms.extensionPlural}}',
  field: 'Campo',
  fieldIsRequired: 'Este campo es obligatorio',
  fieldName: 'Nombre del campo',
  fieldRequired: 'Campo requerido',
  fieldType: 'Tipo de campo',
  fields: 'Campos',
  file: 'Archivo',
  fileFormatPlaceholder: 'seleccione un formato de archivo',
  fileFormatRequired: 'formato requierido',
  fileMandatory: 'Debes subir al menos un archivo',
  fileMustBeImage: 'El archivo debe ser una imagen (jpeg o png)',
  fileSizeExceeded: 'El tamaño del archivo excede el límite de {{size}} MB',
  fileTypeNotSupported: 'Tipo de archivo no soportado',
  files: 'Archivos',
  filesUploadingWillNotBeSaved: 'Los archivos que se están subiendo no serán guardados',
  filesWithErrorWillNotBeSaved: 'Los archivos con error no serán guardados',
  filterByServiceType: 'Filtrar por tipo de {{dictionary.commonTerms.service}}',
  filterByTechnician: 'Filtrar por {{dictionary.profileNames.technician}}',
  filterServices: 'Filtrar {{dictionary.commonTerms.servicePlural}}',
  filters: 'Filtros',
  finalCustomer: '{{dictionary.commonTerms.finalCustomer}}',
  finalCustomerAddress: 'Dirección de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerAge: 'Edad de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerCount: 'Este {{dictionary.commonTerms.finalCustomer}} ya ha tenido previamente',
  finalCustomerCountText:
    '{{dictionary.commonTerms.servicePlural}}. Da clic en el botón de la derecha para ver el detalle.',
  finalCustomerEmail: 'Correo de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerExpeditionDate: 'Fecha de expedición de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerIdentification: 'Identificación de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerIdentificationType: 'Tipo de identificación de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerInfo: 'Información del {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerMobileNumber: 'Celular de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerName: 'Nombre de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerPhone: 'Teléfono de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerPlaceholder: 'Seleccione {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerRequired: '{{dictionary.commonTerms.finalCustomer}} es obligatorio',
  finalCustomerResidenceCity: 'Ciudad de residencia de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerSettings: 'Configuración de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerTags: 'Tags de {{dictionary.commonTerms.finalCustomer}}',
  finalCustomers: '{{dictionary.commonTerms.finalCustomerPlural}}',
  finalCustomersDescription:
    'Si tu entidad emplea listado de {{dictionary.commonTerms.finalCustomerPlural}}, podrás seleccionar el {{dictionary.commonTerms.finalCustomer}} específico al crear {{dictionary.commonTerms.service}}.',
  finalDate: 'Fecha final',
  finalEdition: 'Permitir edición después de finalizar {{dictionary.commonTerms.service}}',
  finish: 'Finalizar',
  finishByFinalCustomerService: 'Finalización por {{dictionary.commonTerms.finalCustomer}}',
  finishChat: 'Finalizar chat',
  finishDate: 'Fecha de finalización',
  finishSequenceStep: 'Finalizar paso',
  finishService: 'Finalizó {{dictionary.commonTerms.service}}',
  finishTime: 'Hora de finalización',
  finishTimeRequired: 'Hora de finalización requerida',
  finished: 'Finalizado',
  finishedAlert: 'Alerta finalizada',
  finishedBy: 'Finalizado por:',
  finishedRetries: 'Reintentos finalizados',
  finishedStep: 'finalizó el paso',
  forceSave: 'Forzar Guardado',
  formIsRequired: 'El Formulario es obligatorio',
  formPlaceholder: 'Seleccione un formulario',
  formWillBeFinish: 'Una vez finalizado no podrá modificar la información registrada',
  forms: 'Formularios',
  frequentResponse: 'Respuesta frecuente',
  frequentResponses: 'Respuestas frecuentes',
  friday: 'Viernes',
  from: 'Desde',
  fromNAvailable: 'de {{n}}',
  fromNumber: 'Desde el número',
  fuchsiaTheme: 'Magenta',
  fullName: 'Nombre',
  fullView: 'Vista completa',
  futureReminder: 'Recordatorio futuro',
  gateways: 'Pasarelas',
  generalConfiguration: 'Configuración general',
  generalConfigurationResolutionsDescription: 'Agrega los datos principales de la numeración',
  generalInfo: 'Información General',
  generalOptions: 'Opciones Generales',
  generate: 'Generar',
  generateAdjustmentNote: 'Generar nota de ajuste',
  generateAdjustmentNoteWarning: 'Una vez generada la nota de ajuste no podrá ser editada',
  generateCreditNote: 'Generar nota crédito',
  generateCreditNoteWarning: 'Una vez generada la nota crédito no podrá ser editada',
  generateInvoice: 'Generar factura',
  generateInvoiceWarning: 'Una vez generada la factura no podrá ser editada',
  generateLinkText: 'Generar enlaces específicos por {{dictionary.profileNames.technician}}',
  generatePDFText: 'Generar PDF de Atención',
  generateReport: 'Generar reporte',
  generated: 'Generado',
  geolocalizationFromUbidots: 'Obtener ubicación de ubidots',
  goBack: 'Regresar',
  gpsTextswitch: 'Solicitar GPS para los reportes',
  grayTheme: 'Gris',
  greenTheme: 'Verde',
  group: 'Grupo',
  groupName: 'Nombre de Grupo',
  headquarter: '{{dictionary.commonTerms.headquarter}}',
  headquarterAddress: 'Dirección de {{dictionary.commonTerms.headquarter}}',
  headquarterDefault: '{{dictionary.commonTerms.headquarter}} general',
  headquarterDescription:
    'Seleccionar {{dictionary.commonTerms.headquarter}} a la que pertenece este {{dictionary.profileNames.operator}}',
  headquarterDescriptionTechnician:
    'Seleccionar {{dictionary.commonTerms.headquarter}} a la que pertenece este {{dictionary.profileNames.technician}}',
  headquarterName: 'Nombre de {{dictionary.commonTerms.headquarter}}',
  headquarterPlaceholder: 'Selecione {{dictionary.commonTerms.headquarter}}',
  headquarterRequired: '{{dictionary.commonTerms.headquarter}} es obligatorio',
  headquarters: '{{dictionary.commonTerms.headquarterPlural}}',
  headquartersTable: 'Sede',
  healthBilling: 'Facturación en Salud',
  healthInsurance: 'EPS',
  healthInsuranceCode: 'Código de la EPS',
  healthInsurancePlaceholder: 'Seleccione una EPS',
  healthInsuranceRequired: 'La EPS es obligatoria',
  healthTypeOperation: 'Tipo de operación',
  here: 'AQUÍ',
  highPriority: '{{dictionary.commonTerms.highPriority}}',
  historyServiceMobileTextSwitch:
    'Permitir visualizar el  histórico de {{dictionary.commonTerms.servicePlural}} en la app móvil',
  historyServiceTextSwitch:
    'Permitir visualizar el  histórico de {{dictionary.commonTerms.servicePlural}} en la app móvil',
  hour: 'Hora',
  hourRequired: 'La hora es requerida',
  hours: 'Horas',
  hoursavailability: 'Horarios y disponibilidad',
  hoursdescription:
    'Si habilitas horarios para el usuario, no podrás asignar {{dictionary.commonTerms.servicePlural}} en horarios que estén por fuera de sus horarios de disponibilidad',
  howOften: '¿Cada cuánto? ',
  howOftenPlaceholder: 'Selecciona cada cuánto',
  htmlEditorDescription: 'Editor en HTML',
  htmlForms: 'Formularios HTML',
  id: 'Consecutivo',
  idSoftware: 'ID del software',
  identification: 'Número de identificación',
  identificationAlreadyExists: 'La identificación ya existe',
  identificationData: 'Datos de identificación',
  identificationPlaceholder: 'Ingrese la identificación',
  identificationRequired: 'La identificación es obligatoria',
  identificationText: 'Identificación',
  identificationType: 'Tipo de identificación',
  identificationandScearchRequired: 'Debes realizar la búsqueda',
  identificator: 'Identificador',
  identificatorPlaceholder: 'Ingrese identificador',
  identifier: 'Identificador',
  identityKeyTestingTitle: 'Llave de identidad de pruebas',
  identityKeyTitle: 'Llave de identidad',
  idiom: 'Idioma',
  image: 'Imagen',
  imageDimensionsError: 'El tamaño de la imagen debe ser {{width}}px por {{height}}px',
  import: 'Importar',
  importAssets: 'Importar {{dictionary.commonTerms.asset}}',
  importCustomList: 'Importar listas personalizadas',
  importCustomListText: 'Descarga la plantilla',
  importCustomListTextModal:
    'para diligenciar la información y luego realiza la importación dando clic en el siguiente botón.',
  importCustomers: 'Importar {{dictionary.commonTerms.customerPlural}}',
  importFinalCustomers: 'Importar {{dictionary.commonTerms.finalCustomerPlural}}',
  importFinalCustomersResult: 'Resultado de importación de {{dictionary.commonTerms.finalCustomerPlural}}',
  importListItems: 'Importar ítems de lista',
  inContestService: 'Lanzó {{dictionary.commonTerms.service}} a concurso',
  inProductionTitle: 'En producción',
  inbound: 'Entrada',
  inboundTransfer: 'Transferencia entrante',
  inboundTransferText: 'Transferencia de salida',
  incidentOutsideSchedule: '{{dictionary.commonTerms.service}} fuera de horario',
  incidentTypeCreate: 'Crear Tipo de {{dictionary.commonTerms.service}}',
  incidentTypeEdit: 'Editar Tipo de {{dictionary.commonTerms.service}}',
  incidentTypeText:
    'Crear tipo de {{dictionary.commonTerms.service}} o editar tipo de {{dictionary.commonTerms.service}} según el caso.',
  info: 'Información',
  infoMessageWhatsapp:
    'Esta información no formará parte del mensaje, servirá para luego identificar en el historial qué tipo de mensaje enviaste',
  infoPatient: 'Información del {{dictionary.commonTerms.finalCustomer}}',
  infoRequired: 'Esta información es obligatoria',
  infoServiceStatus: 'Puede modificar el estado de {{dictionary.commonTerms.service}}',
  infoServiceStatusFromMobile: 'Permitir modificar el estado de {{dictionary.commonTerms.service}} en web',
  infoSwitchAvailability: 'Puede modificar la disponibilidad avanzada',
  informationCaptured: 'Información capturada: ',
  informationNotShowInMessage:
    'Está información no será parte del mensaje, servirá para identificar {{dictionary.commonTerms.surveyPlural}} en el histórico',
  initialDate: 'Fecha inicial',
  inputText: 'Hacia',
  inspectFormService:
    'Con este formulario puedes diligenciar información final como seguimiento de cada {{dictionary.commonTerms.service}}.',
  integrationWhatsapp: 'Integración Whatsapp',
  interested: '{{dictionary.profileNames.interested}}',
  invalidAgeRange: 'La edad para {{documentType}} debe estar entre {{minAge}} y {{maxAge}} años',
  invalidDocumentFormat: 'El formato de {{documentType}} no es válido',
  invalidDocumentType: 'Tipo de documento invalido',
  invalidStatusTransition: 'Transición de estado inválida',
  inventory: 'Inventario',
  inventoryConfiguration: 'Configuración de Inventario',
  inventoryDescription:
    'Lleva el registro del stock de items clave en tu operación, haz seguimiento de tus bodegas , limites y genera reportes',
  inventoryItemCodeDuplicated: 'Código de item duplicado',
  inventoryWarehouseCodeDuplicated: 'Código de bodega duplicado',
  invoiceAlreadyHasAdjustmentNote: 'La factura ya tiene una nota de ajuste asociada',
  invoiceAlreadyHasCreditNote: 'La factura ya tiene una nota crédito asociada',
  invoiceDate: 'Fecha de la factura',
  invoiceHistory: 'Historial de facturación',
  invoiceNumber: 'Número de factura',
  invoicePlaceholder: 'Seleccione una factura',
  invoiceRelated: 'Factura asociada',
  invoiceStatus: 'Estado de la factura',
  invoiceStatusPlaceholder: 'Seleccione el estado de la factura',
  invoiceTemplate: 'Plantilla factura',
  invoices: 'Facturas',
  invoicingFromDate: 'Facturar desde la siguiente fecha',
  isBillable: '¿Es facturable?',
  isNotAValidEmail: 'No es un correo electrónico valido',
  issueDate: 'Fecha emisión',
  itWillBeImported: 'Se importarán {{toBeImported}} de {{total}}',
  item: 'Ítem',
  itemNumberN: 'ítem #{{n}}',
  itemPlaceholder: 'Seleccione un ítem',
  itemRemoved: 'Eliminado',
  itemToBilling: 'Ítem a facturar',
  itemWillBeRemoved: 'Este elemento será eliminado',
  items: 'Ítems',
  itemsToBilling: 'Ítems para facturación',
  keyInvalid: 'El identifcador es invalido',
  keyLabel: 'Identificador',
  keyRequired: 'El identificador es obligatorio',
  landlinePhone: 'Teléfono',
  landlinePhoneNumberPlaceholder: 'Ingrese el teléfono',
  landlinePhonePlaceholder: 'Ingrese un teléfono fijo',
  landlinePhoneRequired: 'El teléfono fijo es obligatorio',
  language: 'Lenguaje',
  languageRequired: 'El lengauaje es obligatorio',
  languageText: 'Seleccione un lenguaje',
  lastLocation: 'Ubicación final',
  lastReportedLocation: 'Última ubicación reportada el',
  lastname1: 'Primer apellido',
  lastname1Placeholder: 'Ingrese el primer apellido',
  lastname1Required: 'El primer apellido es obligatorio',
  lastname2: 'Segundo apellido',
  lastname2Placeholder: 'Ingrese el segundo apellido',
  lastname2Required: 'El segundo apellido es obligatorio',
  latestLocationReport: 'Último reporte de ubicación',
  latitude: 'Latitud',
  legal: 'Legales',
  legalName: 'Nombre legal',
  legalNamePlaceholder: 'Ingrese el nombre legal',
  legalSize: 'Tamaño legal',
  length: 'Duración',
  lengthMaxValidation: '{{label}} debe contener máximo {{max}} caracteres',
  lengthMinValidation: '{{label}} debe contener mínimo {{min}} caracteres',
  lessThanOrEqualValidation: '{{label}} debe ser menor o igual a {{max}}',
  letterSize: 'Tamaño carta',
  lettersAndNumbersOnly: 'Solo se permiten letras y números',
  limitCharacters: 'Excediste el límite de caracteres',
  limitSelfScheduling: 'Limitar el período de autoagendamiento',
  limitSelfSchedulingDescription:
    'Limitar el período futuro habilitado en la página de autoagendamiento al seleccionar {{dictionary.commonTerms.servicePlural}}',
  limitSelfschedulingToCreatedFinalCustomer:
    'Limitar autoagendamiento a {{dictionary.commonTerms.finalCustomerPlural}} creados',
  limitToCreatedFinalCustomer:
    'Solo los {{dictionary.commonTerms.finalCustomerPlural}} que estén creados en la plataforma podrán hacer uso del autoagendamiento',
  limits: 'Limites',
  link: 'Enlace',
  linkCreateHeadquarter: ' puedes crear más {{dictionary.commonTerms.headquarterPlural}}',
  linkCreateSkills: ' puedes crear más {{dictionary.commonTerms.skillsPlural}}.',
  links: 'Enlaces',
  list: 'Lista',
  loading: 'Cargando...',
  loadingCoords: 'Cargando ubicación',
  loadingItems: 'Cargando {{itemsName}}...',
  location: 'Localización',
  locationText: 'Ubicación',
  locks: 'Bloqueos',
  loginAction: 'Ingresar',
  loginTitle: 'Inicio de sesión',
  logo: 'logo',
  logoSizeXY: 'Logo (tamaño {{x}} por {{y}})',
  logoText:
    'Sube tu logo en formato .PNG para que aparezca  en la esquina superior izquierda al interior de la plataforma web. Tamaño obligatorio (Ancho - Alto) 400 x 80.',
  logs: 'Logs',
  longitude: 'Longitud',
  lot: 'Lote',
  lotRequired: 'Lote es obligatorio',
  lowPriority: '{{dictionary.commonTerms.lowPriority}}',
  mainContact: 'Nombre de {{dictionary.commonTerms.contact}} principal',
  mainContactPlaceholder: 'Ingrese el nombre de {{dictionary.commonTerms.contact}} principal',
  mainContactRequired: 'Nombre de {{dictionary.commonTerms.contact}} principal es obligatorio',
  mainEmail: 'Correo electrónico principal',
  mainPageInstructions: 'Instrucciones página principal',
  mainTitle: 'Título principal',
  map: 'Mapa',
  maxDifferenceIs1Month: 'La diferencia máxima entre las fechas debe ser de 1 mes',
  maxStock: 'Stock máximo',
  maxStockText: 'El stock máximo se calculará con base en el stock mínimo',
  medic: 'Médico',
  medicPlural: 'Médicos',
  mediumPriority: '{{dictionary.commonTerms.mediumPriority}}',
  mentionedAssignments: 'Todas las asignaciones mencionadas quedarán ',
  message: 'Mensaje',
  messageAttempts: 'Se intentará enviar un mensaje a todos los {{dictionary.commonTerms.finalCustomerPlural}}  ({{n}})',
  messageDataTerms: 'de datos y los ',
  messageDeletePending: 'Se omitirá la reprogramación y se eliminará del listado de pendientes',
  messageDeletePendingIncident: 'Se omitirá la reprogramación y se eliminará del listado de pendientes',
  messageRequired: 'El mensaje es obligatorio',
  messageTermsAndConditions: 'He leído y acepto la ',
  messengerService: 'Mensajería',
  messengerServiceDescription:
    'Envía mensajes y correos  personalizados a grupos o segmentos de Pacientes directamente, o luego del cumplimiento de algunas reglas',
  messengerServiceWhatsapp: 'Mensajería: Whatsapp',
  minDateError: 'La fecha mínima es {{minDate}}',
  minDateInvoiceError: 'La fecha De la factura no debe ser anterior a hoy',
  minRotationTime: 'El tiempo de rotación debe ser mínimo de {{n}} minutos',
  minStock: 'Stock mínimo',
  minStockText: 'El stock mínimo se calculará con base al promedio del último período seleccionado a continuación',
  minTimeError: 'la hora mínima es {{minTime}}',
  minutes: 'Minutos',
  mobileAppColor: 'Colores de la app móvil',
  mobileAppDescription: 'si tu entidad utiliza la aplicación móvil, podrás configurar algunas opciones de los usuarios',
  mobileAppModuleDescription:
    'Si tu entidad utiliza la aplicación móvil podrás configurar algunas opciones de los usuarios',
  mobileAppModuleText: 'Configuraciones para App móvil',
  mobileForm: 'Formulario de {{dictionary.commonTerms.service}}',
  mobileFormDraftSaved: 'Guardó un borrador de formulario de {{dictionary.commonTerms.service}}',
  mobileFormLink: 'Puedes crear nuevos formularios o editarlos con los campos necesarios.',
  mobileFormRequired: 'Debe seleccionar un formulario de {{dictionary.commonTerms.service}}',
  mobileLogo: 'Logo Móvil',
  mobileLogoText:
    'Sube tu logo en formato .PNG para que aparezca en la barra de menú de la aplicación móvil. Tamaño obligatorio (Ancho - Alto) 270 x 100 pixeles.',
  mobilePhone: 'Celular',
  mobilePhoneNumber: 'Número celular',
  mobilePhonePlaceholder: 'Ingrese un número de teléfono celular',
  mobilePhoneRequired: 'Ingrese el celular',
  model: 'Modelo',
  modules: 'Módulos',
  monday: 'Lunes',
  monthlySurveys: 'Encuestas Mes',
  months: 'Meses',
  moveIncident: 'Mover {{dictionary.commonTerms.service}}',
  moveIncidentDescription: 'Se realizaran los siguientes cambios',
  movedToPending: 'Se moverán al listado de pendientes para no olvidar su reprogramación.',
  movementDate: 'Fecha de movimiento',
  movementDetail: 'Detalle del movimiento',
  movements: 'Movimientos',
  multipleDays: 'Múltiples días',
  municipality: 'Municipio',
  mustAddItemsInvoice: 'Debe agregar al menos un ítem a la factura',
  nAppointments: '{{n}} {{dictionary.commonTerms.servicePlural}}',
  nAttachmentFiles: '{{n}} archivos adjuntos',
  nHours: '{{n}} horas',
  nMinutes: '{{n}} minutos',
  name: 'Nombre',
  name1: 'Primer nombre',
  name1Placeholder: 'Ingrese el primer nombre',
  name1Required: 'El primer nombre es obligatorio',
  name2: 'Segundo nombre',
  name2Placeholder: 'Ingrese el segundo nombre',
  name2Required: 'El segundo nombre es obligatorio',
  nameAccount: 'Nombre de la cuenta',
  nameFile: 'Nombre del archivo',
  namePlaceholder: 'Ingrese el nombre',
  nameRequired: 'El nombre es obligatorio',
  nameTheMessage: 'Asigna un nombre al mensaje',
  nationalityCountry: 'País de nacionalidad',
  nationalityCountryPlaceholder: 'Seleccione un país de nacionalidad',
  nationalityCountryRequired: 'El país de nacionalidad es obligatorio',
  needConfigTemplates: 'Es necesario configurar las plantillas para descargar el archivo.',
  newAccounts: 'Crear',
  newAdjustmentNote: 'Nueva nota de ajuste',
  newAppointment: 'Nueva {{dictionary.commonTerms.service}}',
  newBilling: 'Nueva factura',
  newCreditNote: 'Nueva nota crédito',
  newCustomReport: 'Nuevo reporte personalizado',
  newMovement: 'Nuevo movimiento',
  newNotification: 'Nueva notificación',
  newStock: 'Nuevo stock',
  newValue: 'Nuevo valor',
  next: 'Siguiente',
  nextNumberBilling: 'Número de la próxima factura',
  nit: 'Nit',
  no: 'No',
  noApiKeysGenerated: 'No se han generado API keys',
  noApiKeysGeneratedWhatsapp: 'No se ha generado un key para Whatsapp',
  noAttachments: 'Sin adjunto',
  noBilled: 'No facturado',
  noChatSelected: 'No se ha seleccionado un chat',
  noChatsAvailable: 'No hay chats disponibles',
  noConfigured: 'No configurado',
  noDataTreatmentPolicy: 'No hay política de tratamiento de datos',
  noInfoToShow: 'No hay información para mostrar',
  noLegalTerms: 'No hay términos legales',
  noLoopItems: 'No hay items registrados',
  noRelatedEvents: 'No hay eventos relacionados',
  noResults: 'Sin resultadoos',
  noScheduleTimesAvailable:
    'El {{dictionary.profileNames.technician}} seleccionado no tiene horarios disponibles, por favor seleccione otro.',
  noSchedulesAdded: 'No se han agregado horarios',
  noStocksAvailable: 'No hay stocks disponibles del ítem ( {{item}}) en la bodega ( {{warehouse}})',
  noUploadedDigitalSignature: 'Aún no has cargado tu firma digital',
  noValue: 'Sin valor asignado',
  notActivated: 'No activado',
  notAvailable: 'No disponible',
  notCompleteService: '{{dictionary.commonTerms.service}} no completado',
  notCompletedService: 'Marcó {{dictionary.commonTerms.service}} como No completado',
  notDelivered: 'No Entregado',
  notImportedRecords: 'Registros que no fueron importados',
  notPrioritary: '{{dictionary.commonTerms.notPrioritary}}',
  notStarted: 'Sin iniciar',
  notSupportedField: 'Este elemento no puede ser visualizado en el formato web',
  note: '{{dictionary.commonTerms.note}}',
  notePlural: '{{dictionary.commonTerms.notePlural}}',
  noteTypes: 'Tipo de {{dictionary.commonTerms.note}}',
  noteTypesRequiredMessage: 'Es necesario agregar la nota',
  notes: '{{dictionary.commonTerms.notePlural}}',
  notesInvoiceTemplate: 'Notas de factura',
  notesTypes: 'Tipos de {{dictionary.commonTerms.notePlural}}',
  notification: 'Notificación',
  notificationEvent: 'Evento',
  notificationEventRequired: 'El tipo de evento es obligatorio',
  notificationHour: 'Notificar a una hora especifica',
  notificationSent: 'Notificación enviada',
  notificationSentMessage: 'Enlace de pago enviado exitosamente',
  notificationType: 'Tipo de notificación',
  notificationTypeRequired: 'El tipo de notificación es obligatorio',
  notifications: 'Notificaciones',
  notifyTo: 'Notificar a',
  notifyToRequired: 'El destinatario es obligatorio',
  number: 'Número',
  numberAttemps: 'Numero de intentos',
  numbersOnly: 'Solo se permiten números',
  obligatory: 'Obligatoriedad',
  obligatoryField: 'Obligatorio',
  observation: 'Observación',
  observations: 'Observaciones',
  of: 'el',
  ok: 'Ok',
  onlyNumbersValidation: '{{label}} solo permite caracteres numéricos',
  onlyOneDay: 'Un solo día',
  operator: '{{dictionary.profileNames.operator}}',
  operatorNotComplete: 'Marcó {{dictionary.commonTerms.service}} como No completado',
  operatorPlaceholder: 'Seleccione {{dictionary.profileNames.operator}}',
  optionChat: 'Opción de chat',
  optionChatDescription:
    'Selecciona si este(a) {{dictionary.commonTerms.service}} tendrá la opción de chat con el usuario {{dictionary.profileNames.interested}}',
  optional: '(Opcional)',
  optionalField: 'Opcional',
  optionalMobilePhone: 'Celular opcional',
  optionalMobilePhonePlaceholder: 'Ingrese un número de teléfono celular opcional',
  options: 'Opciones',
  orangeTheme: 'Naranja',
  origin: 'Origen',
  osVersion: 'Versión SO',
  other: 'Otro',
  otherOptions: 'Otras opciones',
  others: 'Otros',
  othersMenus: 'Otros menús',
  outBound: 'Salida',
  outputText: 'Desde',
  pageFooterImage: 'Imagen de pie de Página',
  pageHeaderImage: 'Imagen de Encabezado de página',
  paid: 'Pagado',
  paperType: 'Tamaño de papel',
  participants: 'Participantes',
  partners: 'Colaboradores',
  partnersPlaceholder: 'Seleccione Colaboradores',
  passwordAndConfirmationsMustBeEquals: 'La confirmación de contraseña no coincide',
  passwordDigits: 'La contraseña debe contener {{n}} dígitos',
  passwordLabel: 'Contraseña',
  passwordLength: 'La contraseña debe contener {{n}} caracteres',
  passwordLowercaseLetters: 'La contraseña debe contener {{n}} letras minúsculas',
  passwordPlaceholder: 'Escribe tu contraseña',
  passwordRequiredMessage: 'La contraseña es obligatoria',
  passwordSpecialChars: 'La contraseña debe contener {{n}} de estos caracteres: {{acceptedChars}}',
  passwordUppercaseLetters: 'La contraseña debe contener {{n}} letras mayúsculas',
  patiensHistoryAppointments:
    '{{dictionary.commonTerms.finalCustomerPlural}} que han pedido los siguientes tipos de {{dictionary.commonTerms.servicePlural}}',
  patientHasOverlaps:
    '{{dictionary.commonTerms.finalCustomer}} tiene {{dictionary.commonTerms.servicePlural}} que se cruzan en el mismo horario',
  patientIdConfirmed: 'Identificación del Paciente Confirmado',
  patientIdRejected: 'Identificación del Paciente Rechazado',
  pay: 'Pagar',
  paymentForm: 'Forma de pago',
  paymentGateways: 'Pasarelas de pago',
  paymentMethod: 'Método de pago',
  paymentMethodRequired: 'Debe seleccionar una plataforma para el pago',
  paymentMethodsStepText: 'En el próximo paso se te indicarán los medios de pago',
  paymentPending: 'Pago pendiente',
  paymentPendingDescription: 'Estamos verificando el estado de su pago, este proceso puede tomar unos minutos',
  paymentRejected: 'Pago Rechazado',
  paymentStatus: 'Estado de pago',
  paymentSuccessfully: 'Pago Exitoso',
  pdf: 'PDF',
  pdfConfigDescription: 'Personaliza parcial o totalmente los documentos PDF que se generan',
  pdfConfigText: 'Configuración de PDF',
  pdfFormat: 'Formato PDF',
  pdfFormatBottomBorder: 'Borde inferior (cm)',
  pdfFormatCopyHTMLContent: 'Copiar contenido HTML',
  pdfFormatLeftBorder: 'Borde izquierdo (cm)',
  pdfFormatPlaceholder: 'Selecciona formato ',
  pdfFormatRightBorder: 'Borde derecho (cm)',
  pdfFormatTopBorder: 'Borde superior (cm)',
  pdfFormatsCustom: 'Personalizados',
  pdfFormatsStandard: 'Estándar',
  pdfReports: 'Reportes PDF',
  pdfSettings: 'Configuración de PDF',
  pdfTheme: 'Tema para el PDF',
  pdfThemeDescription: 'Generar PDF para este tipo de {{dictionary.commonTerms.service}}',
  pending: 'Pendiente',
  pendingAlert: 'Alerta pendiente',
  pendingAssignments: 'Pendientes por asignar ',
  pendings: 'Pendientes',
  pendingsBoard: 'Tablero de pendientes',
  pendingsBoardDescription: 'Visualiza un tablero con la lista de {{dictionary.commonTerms.servicePlural}} pendientes',
  period: 'Periodo',
  permission: 'Permissos',
  permissionDenied: 'No tiene permiso para esta operación',
  personCondition: 'Condición',
  personConditionPlaceholder: 'Seleccione condición',
  personInCharge: 'Responsable',
  personalName: 'Nombre del personal',
  personalQuestion: '3.¿Cómo denominas a tu personal?',
  personalization: 'Personalización',
  petition: 'Solicitó {{dictionary.commonTerms.service}}',
  petitionBy: 'Petición hecha por: ',
  petitionDate: 'Fecha de petición: ',
  petitionService: 'Solicitó {{dictionary.commonTerms.service}} ',
  phoneNumber: 'Teléfono',
  phoneNumberPlaceholder: 'Ingrese el teléfono',
  phoneNumberRequired: 'El teléfono es obligatorio',
  pin: 'PIN',
  plural: 'Plural',
  pluralPlaceholder: 'Ingrese Plural',
  policyNumber: 'Número de póliza',
  prefix: 'Prefijo',
  prefixNotAvailable: 'Prefijo no disponible',
  prefixPlaceholder: 'netux',
  prefixRequired: 'El prefijo es obligatorio',
  prefixText: 'Escribe un prefijo o identificador',
  preview: 'Preview',
  previewText: 'Previsualizar',
  previous: 'Atrás',
  previousValue: 'Valor anterior',
  priority: '{{dictionary.commonTerms.priority}}',
  priorityPlaceholder: 'selecciona la prioridad',
  priorityRequired: 'Prioridad requerida',
  privateId: 'Consecutivo',
  productService: 'Producto/Servicio',
  programmed: 'Programado',
  programming: 'Programación',
  programmingDescription:
    'Programa {{dictionary.commonTerms.service}} con antelación para que se repitan múltiples veces en el futuro.',
  publicName: 'Nombre público',
  publicNameRequired: 'El nombre público es obligatorio',
  purchasePrice: 'Valor de compra',
  purchasePriceRequired: 'Valor de compra es obligatorio',
  purpleTheme: 'Morado',
  quantity: 'Cantidad',
  reCaptchaError: 'Error en la verificación, por favor intente de nuevo',
  realTimeAcceptation: 'Aceptación',
  realTimeCreation: 'Creación',
  realTimeStart: 'Inicio',
  realTimeUpdate: 'Actualización en tiempo real',
  realTimeUpdateFrequency: 'Frecuencia de actualización (segundos)',
  reason: 'Motivo',
  recordWillBeRemoved:
    'El registro: {{recordDescription}} será eliminado completamente. Esta acción no se puede deshacer',
  redTheme: 'Rojo',
  reducedView: 'Vista reducida',
  reference: 'Referencia',
  referencePlaceholder: 'Ingrese la referencia',
  referenceRequired: 'La referencia es obligatoria',
  regime: 'Régimen',
  regimePlaceholder: 'Seleccione un régimen',
  regimeRequired: 'El régimen es obligatorio',
  registerAwaitingListTitle: 'Registro en lista de espera',
  registerDataText: 'Puedes registrar tus datos para ser contactado en cuanto haya disponibilidad',
  registerDate: 'Fecha de registro',
  registerInAwaitingList: 'Registrarme en lista de espera',
  rejected: 'Rechazado',
  rejectedBy: 'Rechazado Por: ',
  rejectedDate: 'Fecha de rechazo: ',
  rejectedService: 'Rechazó {{dictionary.commonTerms.service}}',
  relatedEvents: 'Eventos relacionados',
  reload: 'Recargar',
  remainingAssignments: 'asignaciones restantes quedarán',
  remindWhen: 'Recordar cuando',
  remindWhenRequired: 'El cuando recordar es obligatorio',
  reminder: 'Recordatorio',
  remove: 'Eliminar',
  removeDate: 'se eliminará la fecha {{-from}} - {{-to}}',
  removeUserExist: 'No es posible eliminar el {{dictionary.commonTerms.finalCustomer}}',
  removeUserExistDescription: 'Debido a que tiene citas agendadas',
  removed: '¡Eliminado!',
  repeatSurvey: 'Repetir Encuesta',
  repeatTimes: '¿Cuántas veces se repetirá?',
  repeatTimesPlaceholder: 'Selecciona cantidad de veces',
  replenishmentStockText: 'El stock de reposición se calculará con base en el stock mínimo',
  report: 'Reporte',
  reportFieldsConfig: 'Configurar los campos del reporte',
  reportLogo: 'Logo del reporte',
  reportName: 'Nombre del reporte',
  reportNameRequired: 'Nombre del reporte obligatorio',
  reports: 'Reportes',
  reprogramCount: 'Se reprogramarán las',
  reprogrammedCount: 'Se reprogramarán ',
  resStock: 'Stock de reposición',
  reschedule: 'Reprogramar',
  rescheduleCount: 'Se reprogramarán las',
  rescheduleCountTranslation: 'Serán reprogramados',
  reschedulelater: 'Reprogramar luego',
  reserveAnotherAppointment: 'Agendar otra {{dictionary.commonTerms.service}}',
  reserveAppointment: 'Reservar {{dictionary.commonTerms.service}}',
  residenceCity: 'Ciudad de residencia',
  residenceCityRequired: 'La ciudad de residencia es obligatoria',
  residenceDepartment: 'Departamento de residencia',
  residenceDepartmentPlaceholder: 'Seleccione un departamento de residencia',
  residenceDepartmentRequired: 'La departamento de residencia es obligatoria',
  resolution: 'Resolución',
  resolutionDate: 'Fecha de resolución',
  resolutionNumber: 'Número de resolución',
  resolutionPlaceholder: 'Seleccione una resolución',
  resolutionText:
    'Si hubieras podido escoger una fecha diferente a la que seleccionaste para esta cita, por favor indícanos cuál (Resolución 1552 de 2023).',
  resolutions: 'Resoluciones',
  resource: '{{dictionary.profileNames.technician}}',
  resourceDescription:
    'Seleccionar {{dictionary.profileNames.technicianPlural}} que puede gestionar este {{dictionary.profileNames.operator}}',
  resourceManagement: 'Gestión de {{dictionary.profileNames.technicianPlural}}',
  resourceName: 'Nombre de {{dictionary.profileNames.technician}}',
  resourcePlaceholder: 'Selecciona {{dictionary.profileNames.technician}}',
  resources: '{{dictionary.profileNames.technicianPlural}}',
  response: 'Respuesta',
  responseDate: 'Fecha De Respuesta',
  responses: 'Respuestas',
  responsible: 'Responsable',
  retried: 'Reintentado',
  retry: 'Reintentar',
  retryAfter24Hours: 'Se debe reintentar el envío luego de 24 horas sin respuesta',
  retryNumber: 'Numero de reintentos',
  retryPeriod: 'Periodo de reintentos',
  retrySendingAfter24Hours: 'Se debe reintentar el envío luego de 24 horas sin respuesta',
  return: 'Volver',
  review: '{{dictionary.commonTerms.review}}',
  reviewPlural: '{{dictionary.commonTerms.reviewPlural}}',
  reviewYourAvailability: 'Revisa tu disponibilidad, se enviará la confirmación a tu correo electrónico',
  ripsTemplateAdjustmentNote: ' Plantilla RIPs nota de ajuste',
  ripsTemplateCreditNote: 'Plantilla RIPs nota crédito',
  ripsTemplateInvoice: 'Plantilla RIPs factura',
  rotationTime: 'Tiempo de rotación',
  rotationTimeMinutes: 'Tiempo de rotación (minutos)',
  rotationTimeRequired: 'El tiempo de rotación es obligatorio',
  rowInFile: 'Fila en el archivo',
  rules: 'Reglas',
  salesBilling: 'Facturas de venta',
  sampleRequired: '{{sample}} es obligatorio',
  sampleSelectPlaceholder: 'Seleccione {{sample}}',
  satisfactionSurvey: 'Encuesta de satisfacción',
  saturday: 'Sábado',
  save: 'Guardar',
  saveDraft: 'Guardar borrador',
  scheduleLock: 'Bloqueo de horario',
  scheduleSurvey: 'Programar encuesta',
  scheduleTimeNotAvailable: 'Horario no disponible',
  scheduled: 'Programado',
  scheduledAppointments: 'Las siguientes {{dictionary.commonTerms.servicePlural}} están agendadas en ese horario:',
  scholarlyLevel: 'Nivel de escolaridad',
  scholarlyLevelPlaceholder: 'Seleccione un nivel de escolaridad',
  search: 'Buscar',
  searchAppointment: 'Buscar {{dictionary.commonTerms.service}}',
  searchAssignment: 'Buscar asignación',
  searchChat: 'Buscar chat',
  searchCustomerPlaceholder: 'Ingrese nombre o identificación',
  searchItem: 'Buscar ítem',
  searchNearest: 'Buscar más cercano',
  searchRequired: 'Debes realizar la búsqueda',
  searchSkillsPlaceholder: 'Ingrese habilidad',
  searchSpecialist: 'Buscar Especialista',
  secondaryEmail: 'Correo electrónico secundario',
  secondaryEmailPlaceholder: 'Ingrese el correo electrónico secundario',
  secretKeyTestingTitle: 'Llave secreta de pruebas',
  secretKeyTitle: 'Llave secreta',
  seeAllServices: 'Permite visualizar todos los tipos de {{dictionary.commonTerms.servicePlural}}',
  seeAvailableFields: 'Ver campos disponibles',
  seeLocation: 'Ver ubicación',
  selectAppointmentDate: 'Seleccione un día para su cita',
  selectAppointmentTime: 'Seleccione una hora',
  selectAppointmentsTimes: 'Seleccione las horas para la cita',
  selectAsset: 'Seleccione {{dictionary.commonTerms.asset}}',
  selectAssetType: 'Seleccione tipo de {{dictionary.commonTerms.asset}}',
  selectAtLeastOneDay: 'Debe seleccionar al menos un día',
  selectCancellationReasson: 'Seleccione el motivo de cancelación de {{dictionary.commonTerms.service}}',
  selectColorForExportableFormat: 'Seleccione un color para ser usado en el formato exportable',
  selectCompanies: 'Seleccionar {{dictionary.commonTerms.customerPlural}}',
  selectDocument: 'Seleccione un Documento',
  selectEpsPlaceHolder: 'Seleccione eps',
  selectExtension: 'Seleccione una extensión',
  selectFieldType: 'Seleccione el tipo de campo',
  selectFieldsFinalCustomer:
    'Selecciona si los siguientes campos son obligatorios en la creación del {{dictionary.commonTerms.finalCustomer}}',
  selectFieldsToDisplay: 'Seleccione los campos que desea visualizar en los reportes',
  selectFile: 'Seleccionar archivo',
  selectForm: 'Selecciona el formulario que se diligenciará.',
  selectFormText: 'Seleccione formulario',
  selectFormat: 'Selecciona un formato',
  selectFrequentResponse: 'Seleccionar respuesta frecuente',
  selectGroup: 'Seleccione un grupo',
  selectHeadquarter:
    'Selecciona las {{dictionary.commonTerms.headquarterPlural}} que aplican para este tipo de {{dictionary.commonTerms.service}}. También',
  selectInventoryItem: 'Selecciona Item',
  selectItem: 'Seleccione el tipo de m',
  selectLocalization: 'Seleccionar ubicación',
  selectMessageSendingStart: 'Selecciona el momento en que empezará el envío de los mensajes',
  selectMovementType: 'Seleccione el tipo de movimiento',
  selectNewStatus: 'Seleccione el nuevo estado para este {{dictionary.commonTerms.service}}',
  selectOption: 'Seleccione una opción',
  selectPatienText:
    'Selecciona los campos específicos del {{dictionary.commonTerms.finalCustomer}} que éste deberá diligenciar al momento de autoagendarse',
  selectPaymentProviders: 'Seleccione una opción para realizar el pago: ',
  selectPreferredAction: 'Seleccione la acción que prefiera aplicar',
  selectRecipientForMessages: 'Selecciona a quién enviarás los mensajes',
  selectSequence: 'Seleccione una secuencia',
  selectServiceType: 'Selecciona los tipos de {{dictionary.commonTerms.service}} que se puede crear',
  selectSkills:
    'Selecciona las {{dictionary.commonTerms.skillsPlural}} que aplican para este tipo de {{dictionary.commonTerms.service}}. También',
  selectSkillsBrief: 'Selecciona las {{dictionary.commonTerms.skillsPlural}}',
  selectSkillsCanSeeReports: 'Selecciona las {{dictionary.commonTerms.skillsPlural}} que tendrán acceso a este reporte',
  selectSolution: 'Seleccione el tipo de solución',
  selectStatus: 'Seleccione un estado',
  selectSurvey: 'Seleccione una encuesta',
  selectSurveyToSend: 'Seleccione Encuesta a enviar',
  selectTechnicianAndDate:
    'Seleccione un {{dictionary.profileNames.technician}} y una fecha para buscar la posibilidad de reasignación:',
  selectTemplate: 'Seleccione plantilla',
  selectTheAppointment: 'Elige la cita',
  selectTheTimeToSendMessage: 'Selecciona el momento en que empezará el envío de los mensajes',
  selectTypeUserPlaceholder: 'Selecciona el tipo de usuario',
  selectWebForm: 'Seleccione formulario',
  selectWhoYou: 'Selecciona a quién le enviarás tu mensaje',
  selectedAsset: '{{dictionary.commonTerms.asset}}',
  selectedContact: 'Contacto',
  selectedFinalCustomer: '{{dictionary.commonTerms.finalCustomer}}',
  selfScheduled: 'Autoagendado',
  selfScheduling: 'Autoagendamiento',
  selfSchedulingAccessLink: 'Enlace de acceso',
  selfSchedulingInstructions: 'Instrucciones para este tipo de {{dictionary.commonTerms.service}}',
  selfSchedulingLengthInstructions:
    'Defina cuanto debe durar, tenga en cuenta que este tiempo determinará las horas a mostrar en la página de autoagendamiento',
  selfSchedulingPublicNameInstructions: 'Este es el nombre que veran los usuarios en la página de autoagendamiento',
  send: 'Enviar',
  sendEmail: 'Enviar correo',
  sendReminderService: 'Enviar recordatorio de {{dictionary.commonTerms.service}}',
  sendTestSet: 'Enviar set de prueba',
  sendThen: 'Enviar luego de ',
  sent: 'Enviado',
  sentBy: 'Enviado por',
  sentCreditNote: 'Enviar nota crédito',
  sentInvoice: 'Enviar factura',
  sentMessages: 'Enviar mensajes',
  sequence: 'Secuencia',
  sequenceWillBeRemoved: 'La secuencia será eliminada',
  sequences: 'Secuencias',
  servedBy: 'Atendido por',
  service: '{{dictionary.commonTerms.service}}',
  serviceAssigned: 'Asignación de {{dictionary.commonTerms.service}}',
  serviceAssignment: 'Asignación de {{dictionary.commonTerms.servicePlural}}',
  serviceBilling: 'Facturando {{dictionary.commonTerms.service}}',
  serviceCanceled: 'Cancelación de {{dictionary.commonTerms.service}}',
  serviceConfirmation: 'Confirmación de {{dictionary.commonTerms.service}}',
  serviceConfirmationChatNoReschedule: 'Confirmación de {{dictionary.commonTerms.service}} (Chat - Sin reagendamiento)',
  serviceDate: 'Fecha',
  serviceDatePlaceholder: 'Ingrese la fecha',
  serviceDateRequired: 'La fecha es obligatoria',
  serviceDescription: 'Descripción',
  serviceDescriptionPlaceholder: 'Ingrese descripción',
  serviceDescriptionRequired: 'Descripción es obligatoria',
  serviceFinished: 'Finalización de {{dictionary.commonTerms.service}}',
  serviceId: 'ID',
  serviceInformation: 'Información de {{dictionary.commonTerms.service}}',
  serviceModified: 'Modificación de {{dictionary.commonTerms.service}}',
  serviceName: 'Nombre de {{dictionary.commonTerms.service}}',
  serviceNamePlaceholder: 'Ingrese nombre {{dictionary.commonTerms.service}}',
  serviceNameRequired: 'Nombre {{dictionary.commonTerms.service}} es obligatorio',
  serviceSpeciality: '{{dictionary.commonTerms.skillsPlural}} de {{dictionary.commonTerms.service}}',
  serviceStatus: 'Estado de {{dictionary.commonTerms.service}}',
  serviceTags: 'Tags',
  serviceTime: 'Hora',
  serviceTimePlaceholder: 'Ingrese la hora',
  serviceTimeRequired: 'La hora es obligatoria',
  serviceType: 'Tipo de {{dictionary.commonTerms.service}}',
  serviceTypeNotAssignedToHeadquarter:
    'El tipo de {{dictionary.commonTerms.service}} no está asignado a {{dictionary.commonTerms.headquarter}}',
  serviceTypeNotAssignedToX: 'El tipo de {{dictionary.commonTerms.service}} no está asignado a {{x}}',
  serviceTypePlaceholder: 'Seleccione un tipo de {{dictionary.commonTerms.service}}',
  serviceTypeRequired: 'Tipo de {{dictionary.commonTerms.service}} es obligatorio',
  serviceTypeText: 'Nuevo tipo de {{dictionary.commonTerms.service}}',
  serviceTypes: 'Tipo de {{dictionary.commonTerms.servicePlural}}',
  serviceWillBeCanceled: '{{dictionary.commonTerms.service}} se cancelará',
  serviceWillBeFinished: '{{dictionary.commonTerms.service}} se finalizará',
  services: '{{dictionary.commonTerms.servicePlural}}',
  servicesByAsset: '{{dictionary.commonTerms.servicePlural}} por {{dictionary.commonTerms.asset}}',
  servicesByCustomer: '{{dictionary.commonTerms.servicePlural}} por {{dictionary.commonTerms.customer}}',
  servicesByType: '{{dictionary.commonTerms.servicePlural}} por tipo',
  servicesByUser: '{{dictionary.commonTerms.servicePlural}} por usuario',
  servicesCanceled: 'Cancelados',
  servicesConfirmed: 'Confirmados',
  servicesCreated: 'Creados',
  servicesForOperator: '{{dictionary.commonTerms.servicePlural}} por {{dictionary.profileNames.operator}}',
  servicesForResource: '{{dictionary.commonTerms.servicePlural}} por {{dictionary.profileNames.technician}}',
  servicesFromAtoB: '{{dictionary.commonTerms.servicePlural}} desde {{a}} hasta {{b}}',
  servicesHistory: 'Historial de {{dictionary.commonTerms.servicePlural}}',
  servicesLanding: 'Landing de {{dictionary.commonTerms.servicePlural}}',
  servicesPerDay: '{{dictionary.commonTerms.servicePlural}} por día',
  servicesSelfScheduled: 'Autoagendados',
  servicesTypesAssigned:
    'Seleccione los tipos de {{dictionary.commonTerms.servicePlural}} con permiso de visualización',
  setTestId: 'Id set de pruebas',
  shippingDate: 'Fecha de envio',
  shortDescription: 'Descripción corta',
  showLocation: 'Mostrar ubicación',
  signDocumentDescription: 'Usa tu mouse o tu mano para dibujar tu firma en este espacio:',
  signOut: 'Cerrar sesión',
  signature: 'Firma',
  signatureCity: 'Ciudad en que se firma',
  signatureDate: 'Fecha en que se firma el Documento',
  signatureDay: 'Día en que se firma el Documento',
  signatureDocument:
    '¿Se require firmar un Documento antes de acceder a la sala de {{dictionary.commonTerms.videoConsultation}}?',
  signatureHour: 'Hora en que se firma el Documento',
  signatureMonth: 'Mes en que se firma el Documento',
  signatureYear: 'Año en que se firma el Documento',
  signedDocument: 'Doc firmado',
  singular: 'Singular',
  singularPlaceholder: 'Ingrese singular',
  siteName: 'Escribe el nombre que aparecerá en la pestaña del navegador',
  siteTitle: 'Titulo del sitio',
  skillPlaceholder: 'Selecciona las habilidades',
  skillWillBeRemoved: 'Este registro será eliminado completamente.',
  skills: '{{dictionary.commonTerms.skillsPlural}}',
  skillsDescription: ' Selecciona {{dictionary.commonTerms.skillsPlural}} para este Recurso. ',
  skillsDescriptionFinish: 'y asociarlas a los tipos de {{dictionary.commonTerms.service}}',
  skillsDescriptionLink: 'También puedes crear más {{dictionary.commonTerms.skillsPlural}} ',
  skillsForCustomPdf: '{{dictionary.commonTerms.skillsPlural}} con acceso a este PDF',
  skillsRequired: 'Debe seleccionar al menos una {{dictionary.commonTerms.skills}}',
  skillsVisiblesToService: 'Habilidades visibles para este menú',
  solutionRequired: 'Es necesario seleccionar un tipo solución',
  solutionType: 'Tipo de solución',
  someFieldsHaveErrors: 'Hay campos que presentan errores',
  spanish: 'Español',
  specialist: 'Especialista',
  specialistPlural: 'Especialistas',
  specialities: '{{dictionary.commonTerms.skillsPlural}}',
  specificEmail: 'Correo específico',
  start: 'Inicio',
  startChat: 'Iniciar',
  startConversation: 'Iniciar conversación',
  startDate: 'Fecha de inicio',
  startDateOfService: 'Fecha inicio atención',
  startHour: 'Hora de inicio',
  startService: 'Iniciar {{dictionary.commonTerms.service}}',
  startTime: 'Hora de inicio',
  startTimeRequired: 'Hora de inicio requerida',
  startTimeShouldBeGreater: 'La hora de finalización debe ser mayor',
  startedService: 'Inició {{dictionary.commonTerms.service}}',
  startedStep: 'inició el paso',
  states: 'Estados',
  statistics: 'Estadísticas',
  status: 'Estado',
  statusChangeNotAllowed: 'Cambio de estado no permitido',
  statusRequired: 'Estado requerido',
  stepNameRequired: 'El nombre del paso es obligatorio',
  steps: 'Pasos',
  stepsRequired: 'Debes agregar mínimo un paso',
  stock: 'Stock',
  stockAlert: 'Stock de alerta',
  stockDetail: 'Detalle del Stock',
  stocks: 'Stocks',
  subTotal: 'Subtotal',
  subject: 'Asunto',
  subjectRequired: 'El asunto es obligatorio',
  succesSendMessages:
    'Se intentará enviar un mensaje a todos los {{dictionary.commonTerms.finalCustomerPlural}}. Tenga en cuenta que si alguno de ellos no tiene un número válido registrado, no recibirá la notificación.',
  success: 'Éxito',
  successAddingInAwaitingList: 'Ha sido añadido a la lista de espera con éxito',
  successCancelingService: 'Cancelación de {{dictionary.commonTerms.service}} exitosa',
  successCreateToken: 'Token generado con éxito',
  successCreatingCancellation: 'Cancelación creada con éxito',
  successCreatingRecord: 'Registro creado con éxito',
  successDeleteSkill: 'Registro eliminado con éxito',
  successFinishingService: 'Finalización de {{dictionary.commonTerms.service}} exitosa',
  successRemoveService: '{{dictionary.commonTerms.service}} eliminada con éxito',
  successRemovingRecord: 'Registro eliminado con exito',
  successSendNotification: 'Envio de notificación exitoso',
  successSentEmail: 'Correo enviado con éxito',
  successStartingService: '{{dictionary.commonTerms.service}} ahora está en proceso',
  successUpdatingRecord: 'Registro actualizado con exito',
  successUploadingFile: 'Archivo subido con éxito',
  successValidateFile: 'Archivo de validación listo para su revisión',
  successvalidatedFile: 'Archivo Validado con éxito',
  summary: '{{dictionary.commonTerms.summary}}',
  sunday: 'Domingo',
  supportChat: 'Chat de soporte',
  supportChatDescription:
    'Habilita el chat de soporte para que los {{dictionary.commonTerms.finalCustomerPlural}} puedan comunicarse con el equipo de soporte',
  surveyGroupIsRequired: 'Es necesario seleccionar un grupo de encuesta',
  surveyHistory: 'Histórico de Encuestas',
  surveyInfoNotPartOfMessage:
    'Esta información no será parte del mensaje, servirá para identificar Encuestas luego en el histórico',
  surveyIsRequired: 'Es necesario escoger una encuesta',
  surveySuccessfullySuspended: '{{dictionary.commonTerms.surveyPlural}} suspendidas con éxito',
  surveys: 'Encuestas',
  surveysDescription: 'Realiza el envío de Encuestas por medio de Whatsapp a tus Clientes finales',
  surveysGroup: 'Grupo de Encuestas',
  suspend: 'Suspender',
  suspendSurvey: 'Suspender {{dictionary.commonTerms.surveyPlural}}',
  synchronizedBy: 'Sincronizados por: ',
  synchronizedData: 'Sincronizó información parcialmente',
  synchronizedDate: 'Fecha de sincronización: ',
  synchronizedService: 'Sincronizó {{dictionary.commonTerms.service}}',
  tags: 'Tags',
  tagsPlaceholder: 'Ingresa los Tags del {{dictionary.commonTerms.finalCustomer}}',
  task: 'Tareas',
  tax: 'Impuesto',
  taxObligation: 'Obligación tributaria',
  technicalKey: 'Llave técnica',
  technician: '{{dictionary.profileNames.technician}}',
  technicianPlaceholder: 'Seleccione {{dictionary.profileNames.technician}}',
  technicianPlural: '{{dictionary.profileNames.technicianPlural}}',
  technicianRequired: '{{dictionary.profileNames.technician}} es obligatorio',
  technicianScheduleOverlaps:
    '{{dictionary.profileNames.technician}} ya tiene otra asignación que se cruza con la hora que desea asignar',
  techniciansMap: 'Mapa de Recursos',
  techniciansMapDescription: 'Visualiza en un mapa las últimas ubicaciones por los usuarios móviles',
  techniciansNear: '{{dictionary.profileNames.technicianPlural}} cercanos',
  techniciansTracking: 'Seguimiento de {{dictionary.profileNames.technicianPlural}}',
  techniciansTrackingDescription:
    'Visualiza la ubicación de los {{dictionary.profileNames.technicianPlural}} y la geolocalización de los puntos clave',
  template: 'Plantilla',
  templateRequired: 'La plantilla es obligatoria',
  templates: 'Plantillas',
  terms: 'Términos',
  termsAndConditionsMessage: 'términos y condiciones',
  termsAndConditionsTitle: 'Términos Y Condiciones',
  testSetApprovedDian: 'El set de pruebas ya fue aprobado por la DIAN',
  textAccountuser:
    'Para ingresar a tu cuenta puedes usar tu nombre de usuario {{prefix}}.{{username}} y la contraseña que ingresaste',
  textCopyToClipBoard: 'El texto se ha copiado al portapapeles',
  textField: 'Campo de texto',
  textGenerate: 'Se ha generado una nueva api key',
  the: ' de',
  theFollowingAppointments: 'Las siguientes asignaciones están agendadas en ese horario:',
  theFollowingAppointmentsCalendar: 'En este horario se encontraron las siguientes asignaciones:',
  thereAreActiveAndUnassignedChats: 'Hay chats activos y sin asignar',
  thereAreActiveChats: 'Hay chats activos',
  thereAreNoOtherOptionsEnabled: 'No hay otras opciones habilitadas para esta cuenta',
  thereAreServicesAssignedWarning: 'Hay asignaciones agendadas para este horario',
  thereAreUnassignedChats: 'Hay chats sin asignar',
  thereIsNewMessages: 'Hay mensajes nuevos',
  thereIsNoReviewInfo: 'No hay información de revisión',
  thisActionCannotBeUndone: 'Esta acción no se podrá deshacer',
  thisFieldIsRequired: 'Este campo es obligatorio',
  thisRecordWillBeRemoved: 'Este registro será eliminado',
  thursday: 'Jueves',
  time: 'Tiempo',
  timeExecution: 'Tiempo de ejecución en minutos',
  timeFormat: 'Formato del horario',
  timeLineFrom: 'De',
  timeUnit: 'Unidad de tiempo',
  timeUnitPlaceholder: 'Días, semanas, meses, años',
  timeUnitPlaceholderPleace: 'Selecciona unidad de tiempo',
  timeUnitRequired: 'Unidad de tiempo',
  timeZone: 'Zona horaria',
  timeZoneExample: '(UTC-05:00) Bogota, Lima, Quito',
  timeZoneText: 'Seleccione su zona horaria',
  timezoneRequired: 'La zona horaria es obligatoria',
  titleCardselfScheduling: 'Página de autoagendamiento',
  titleErrorNotification: 'No es posible crear esta notificación',
  tittleIntegrationwhatsapp: 'Integración Whatsapp',
  to: 'a',
  today: 'Hoy',
  tokenMetaMessage: 'Ingresa el token permanente generado por Meta',
  tokenWillBeRemoved: 'El token será eliminado está acción es irreversible',
  topic: '{{dictionary.commonTerms.topic}}',
  topicPlural: '{{dictionary.commonTerms.topicPlural}}',
  total: 'Total',
  totalAssetsText: 'Se importarán {{a}} de {{n}}',
  totalItems: 'Total de ítems',
  totalPrice: 'Precio total',
  totalQuantityText: 'Cantidad total :',
  towards: 'Hacia',
  tradeName: 'Nombre comercial',
  transfer: 'Transferencia',
  transferChat: 'Transferir chat',
  transferIndboundText: 'Transferencia de entrada',
  transferReason: 'Razón de transferencia',
  transferTo: 'Transferir a',
  transferredChat: 'Chat transferido',
  transfers: 'Transferencias',
  trialPeriod: 'Periodo de intentos',
  tuesday: 'Martes',
  type: 'Tipo',
  typeCoverageServicePlan: 'Tipo de cobertura o plan de servicios',
  typeOfExam: 'Tipo de examen',
  typeUserHealthSector: 'Tipo de usuario sector salud',
  typeUsertext: 'Selecciona el tipo de usuario, ingresa la Información básica y asigna una contraseña',
  unassignedChats: 'Sin asignar',
  unassignedText: 'Sin asignar',
  unconfirmedAppointment: 'No confirmado',
  unfilledFields: 'Campos sin diligenciar',
  unfilledText: 'No ha seleccionado campos obligatorios para la creación de este(a) {{dictionary.commonTerms.service}}',
  unit: 'Unidad',
  unitPrice: 'Precio unitario',
  unitValue: 'Valor unitario',
  until: 'Hasta',
  upToNumber: 'Hasta el número',
  updateInProcess: 'Actualización en proceso',
  updateList: 'Editar lista',
  updateListNode: 'Actualizar nodo',
  updateMobileForm: 'Actualizó información de {{dictionary.commonTerms.service}}',
  updatePasswordText: 'Cambiar contraseña',
  updatePendingFinish: 'En revisión',
  updated: '¡Actualizado!',
  updatedBy: 'Actualizado por: ',
  updatedDate: 'Fecha de actualización',
  updatedFields: 'Campos actualizados',
  updatedMobileFormDate: 'Fecha de formulario móvil completado: ',
  updatedMobileFormdBy: 'Formulario móvil actualizado por: ',
  updatedRecords: 'Registros actualizados',
  updatedReviewForm: 'Modificó formulario de {{dictionary.commonTerms.review}}',
  upload: 'Cargar',
  uploadDigitalCertificate: 'Subir certificado digital',
  uploadDigitalSignature: 'Cargar firma digital',
  uploadImportsTemplateMessage: 'Subir plantilla diligenciada',
  uploadTemplate: 'Subir plantilla',
  uploadingFile: 'Subiendo archivos...',
  urlFinalCustomerRoom: 'URL sala {{dictionary.commonTerms.finalCustomer}}',
  urlResourcesRoom: 'URL sala {{dictionary.profileNames.technician}}',
  urlVideoConsultation: 'URL sala de {{dictionary.commonTerms.videoConsultation}}',
  user: 'Usuario',
  userAdmin: 'Usuario administrador',
  userAdminPlaceholder: 'admin',
  userAdminRequired: 'Usuario administrador es obligatorio',
  userCannotPerformService:
    '{{dictionary.profileNames.technician}} no puede realizar este tipo de {{dictionary.commonTerms.service}}',
  userDevices: 'Dispositivos del usuario',
  userDevicesLogs: 'Logs de ubicación del usuario',
  userHasOverlaps:
    '{{dictionary.profileNames.technician}} tiene {{dictionary.commonTerms.servicePlural}} que se cruzan en el mismo horario',
  userNotAssignedToHeadquarter:
    '{{dictionary.profileNames.technician}} no está asignado a {{dictionary.commonTerms.headquarter}}',
  userNotAssignedToX: '{{dictionary.profileNames.technician}} no está asignado a {{x}}',
  userNotAvailable: '{{dictionary.profileNames.technician}} no está disponible en el horario seleccionado',
  userPlaceholder: 'Selecciona el usuario',
  userType: 'Tipo de Usuario',
  userTypeConfigBase: 'Tipo de usuario y configuración base',
  userTypeDescriptiontitle: 'Ten en cuenta que',
  userTypeInterestedDescription:
    ' El usuario {{dictionary.profileNames.interested}}  utiliza la plataforma web y solo se le permite la visualización de reportes',
  userTypeOperatorDescription:
    'El usuario {{dictionary.profileNames.operator}} utiliza la plataforma web y se enfoca en el agendamiento y seguimiento de Citas',
  userTypeRequired: 'tipo de usuario es obligatorio',
  userTypeTechnicianDescription:
    'El usuario {{dictionary.profileNames.technician}} se encarga de realizar/atender {{dictionary.commonTerms.servicePlural}} Dependiendo la configuración de tu cuenta puede utilizar la aplicación web o la aplicación móvil',
  userWillBeDisabled: 'El usuario será deshabilitado y no podrá ingresar a la plataforma',
  username: 'Nombre de usuario',
  usernameAlreadyExists: 'Nombre de usuario ya existe',
  usernameDescription: 'El usuario deberá usar {{username}} para ingresar a la aplicación',
  usernameLabel: 'Usuario o correo electrónico',
  usernamePlaceholder: 'Escribe tu usuario o correo electrónico',
  usernameRequired: 'Debes ingresar un nombre de usuario',
  usernameRequiredMessage: 'Debes ingresar un usuario o correo electrónico',
  users: 'Usuarios',
  validationErrorTitle: 'Errores de Validación',
  validationRemindWhen: 'El valor no puede ser menor o igual a 0',
  validityFrom: 'Vigencia desde',
  validityUntil: 'Vigencia hasta',
  value: 'Valor',
  valueLabel: 'Valor',
  valuePlaceholder: 'Ingrese valor',
  valueRequired: 'El valor es obligatorio',
  valueToPay: 'Valor a pagar: ',
  values: 'Valores',
  variableCreate: 'Crear variable',
  variableEdit: 'Editar variable',
  variables: 'Variables',
  variablesDescription: 'Habilitar variables a este tipo de atención',
  verificationDocumentText: 'No se puede guardar esta información',
  verifyAssignations: 'Verificar asignaciones',
  version: 'Version',
  video: 'Video',
  videoConsultationConfiguration: 'Configuración de {{dictionary.commonTerms.videoConsultation}}',
  videoConsultationEnable: 'Opción de {{dictionary.commonTerms.videoConsultation}}',
  videoConsultationEnableDescription:
    'Con esta opción, al crear este tipo de {{dictionary.commonTerms.service}} podrá atenderse por medio de {{dictionary.commonTerms.videoConsultation}}',
  videoconsultation: '{{dictionary.commonTerms.videoConsultation}}',
  videoconsultationAssignation:
    'Asignación de {{dictionary.commonTerms.service}} ({{dictionary.commonTerms.videoConsultation}})',
  videoconsultationConfirmation:
    'Confirmación de {{dictionary.commonTerms.service}} ({{dictionary.commonTerms.videoConsultation}})',
  videoconsultationRoom: 'Sala de {{dictionary.commonTerms.videoConsultation}}',
  videoconsultationRoomDescription: 'Habilitar sala de {{dictionary.commonTerms.videoConsultation}}',
  viewAccounts: 'Ver cuentas',
  viewAllAuthorsServices: 'Permite visualizar {{dictionary.commonTerms.servicePlural}} de todos los autores',
  viewAllCustomers: 'Visualizar todos los {{dictionary.commonTerms.customerPlural}}',
  viewContainer: 'Ver contenedor',
  viewCustomers: 'Visualizar {{dictionary.commonTerms.customerPlural}}',
  viewCustomersText:
    'El usuario podrá ver el listado de {{dictionary.commonTerms.customerPlural}} y seleccionar uno de acuerdo con su prefetencia. Selecciona NO únicamente si no tienes creado ningún {{dictionary.commonTerms.customer}}.',
  viewDetails: 'Ver detalles',
  viewMore: 'Ver más',
  viewServicesCustomers:
    'Visualizar {{dictionary.commonTerms.servicePlural}} de {{dictionary.commonTerms.customerPlural}}',
  viewServicesCustomersDescription: 'Visualizar información de todos los {{dictionary.commonTerms.customerPlural}}',
  viewSurvey: 'Visualizar Encuesta',
  viewUpdatedFields: 'Ver campos actualizados',
  viewUsers: 'Visualizar {{dictionary.profileNames.technicianPlural}}',
  viewUsersText:
    'El usuario podrá ver el listado de {{dictionary.profileNames.technicianPlural}} y seleccionar de acuerdo a su preferencia. Si seleccionas NO el usuario no verá el listado de {{dictionary.profileNames.technicianPlural}} y en ese caso se asignará de forma aleatoria uno que esté disponible.',
  viewedBy: 'Visto por',
  viewwingModeText:
    'Tu cuenta está en modo visualización, no podrás crear {{dictionary.commonTerms.servicePlural}}. Comunícate con un asesor para activarla nuevamente',
  visibleHistoryFields: 'Campos visibles en Histórico',
  waitForFinalCustomer: 'En espera de {{dictionary.commonTerms.finalCustomerPlural}}',
  waitForFinalCustomerResponse: 'Esperando respuesta de {{dictionary.commonTerms.finalCustomer}}',
  waitingForResponse: 'Esperando Respuesta',
  warehouse: 'Bodega',
  warehouses: 'Bodega',
  warnServiceWithoutFinalCustomerToInvoice:
    'No puedes facturar este(a) {{dictionary.commonTerms.service}} debido a que no tiene ningún {{dictionary.commonTerms.finalCustomer}} asociado.',
  warning: 'Advertencia',
  warningWarehouseChange: 'Al cambiar la Bodega se borrará el listado de ítems que se han agregado',
  webhookMessage: 'En Meta necesitas también ingresar el webhook. Recuerda que es el siguiente:',
  wednesday: 'Miércoles',
  week: 'Semana',
  weeks: 'Semanas',
  welcomeText: '¡Bienvenido! Diligencia la siguiente información para crear tu cuenta',
  whatsAppDeliveryReminder: 'Habilitar botón de envío de recordatorio por whatsapp',
  whatsapp: 'Whatsapp',
  whatsappScheulding: 'Permitir agendamiento por Whatsapp',
  whoSignDocument: '¿Quién firma el documento?',
  widgetsExternal: 'Widgets externos',
  willBeAssigned: 'Se asignarán',
  willLoseConditionalValues:
    'Cambiar la selección resultará en la perdida de los valores condicionales asociados a la selección actual. ¿Desea proceder?',
  wineries: 'Bodegas',
  winery: 'Bodega',
  wineryRequire: 'La bodega es obligatoria',
  withoutAlert: 'Sin alerta',
  wppNumberHasActiveChats: 'El número de teléfono tiene chats activos',
  writeAMessage: 'Escribe un mensaje',
  wrongValue: 'Valor erroneo',
  xNotAssignedToY: '{{x}} no está asignado a {{y}}',
  years: 'Años',
  yes: 'Si',
  you: 'Tú',
  yourAppointmentWillBeConfirmed: 'Tu cita será confirmada',
  zipNumberN: 'Zip número {{n}}',
  zipsList: 'Listado de zips',
};
